<template>
  <div class="app" onselectstart="return false" ref="app">
    <div class="leftChat" ref="leftChat" :style="leftChatStyle">
      <div ref="body" class="body" id="my-node" :style="wrapperStyle">
        <img
          v-if="backgroundImage"
          class="backimg"
          :src="backgroundImage"
          alt=""
        />
        <vue-draggable-resizable
          ref="drag"
          @changeLevel="changeLevel"
          @changeLevelData="changeLevelData"
          @rotating="dragRotating"
          @dragging="dragMoving"
          @resizing="dragResizing"
          @handleUnlock="handleUnlock"
          :className="item.selects ? 'vdr select' : 'vdr'"
          :w="item.width"
          :textShadow="item.textShadow ? true : false"
          :h="item.height ? item.height : 0"
          :x="item.left"
          :y="item.top"
          :r="item.rotate"
          :z="item.zIndex"
          :parent="true"
          :minWidth="12"
          :minHeight="12"
          :level="item.level"
          :levelType="item.levelType"
          :levelNum="item.levelNum"
          :fontFamily="item.fontFamily"
          @changeHeight="changeHeight"
          :frameId="'frame' + index"
          :photoScale="item.photoScale"
          :photoLeft="item.photoLeft"
          :photoTop="item.photoTop"
          :showPhoto="item.showPhoto"
          :shadow="item.shadow ? true : false"
          :allIndex="allIndex"
          :dIndex="index"
          :debug="false"
          :textDecoration="item.textDecoration"
          :textIndent="item.textIndent"
          :photoRotate="item.photoRotate"
          :writingMode="item.writeMode"
          :lineHeight="item.lineHeight"
          :fontWeight="item.fontWeight"
          :fontStyle="item.fontStyle"
          :textAlign="item.textAlign"
          :type="item.type"
          :isConflictCheck="false"
          :snap="true"
          :snapTolerance="1"
          :lockAspectRatio="item.lockAspectRatio ? true : false"
          :backImg="item.backgroundImg ? item.backgroundImg : ''"
          :bImg2="item.backImg2"
          :bRadius="item.borderRadius"
          :draggable="item.draggable"
          @refLineParams="getRefLineParams"
          @activated="changeDrag(index)"
          @changeContent="changeContent"
          @showEdit="showEdit"
          :fontColor="item.fColor"
          :text="item.textarea"
          :o="item.opacity"
          :l="item.lock ? true : false"
          :backColor="item.bColor"
          :borderColor="item.bordersColor"
          :borderLeft="item.bLeft"
          :borderTop="item.bTop"
          :borderRight="item.bRight"
          :borderBottom="item.bBottom"
          :borderStyle="item.bStyle"
          :paddingLeft="item.paddingLeft"
          :paddingTop="item.paddingTop"
          :paddingRight="item.paddingRight"
          :paddingBottom="item.paddingBottom"
          :shiftKey="item.shiftKey ? true : false"
          :fontSize="item.fSize"
          v-for="(item, index) in drags"
          :key="item.key"
          @changeDrag="changeDragHistory"
          @pmoving="pmoving"
          @resizestop="resizing"
          @movingStop="movingStop"
          @rotatingStop="rotating"
          @dragstop="dragging"
          @upTop="upTop(index)"
          @mouseEnter="listenMouseEnter"
          @mouserLeave="listenMouseLeave"
          @confirmComb="confirmComb"
          @dropImg="dropImg"
        >
          <div v-if="item.coms" class="look" style="z-index: -1">
            <div
              class="wrap"
              :style="{
                width: '100%',
                height: '100%',
                transform: `scale(${item.width /
                  item.orignWidth},${item.height / item.orignHeight})`,
                transformOrigin: '0px 0px',
              }"
            >
              <vue-draggable-resizable
                v-for="(item2, index2) in item.coms"
                :key="index2"
                :w="item2.width"
                :h="item2.height"
                :enableNativeDrag="true"
                :x="item2.left"
                :y="item2.top"
                :r="item2.rotate"
                :z="item2.zIndex"
                :showCanvasImg="showCanvasImg"
                :photoScale="item2.photoScale"
                :photoLeft="item2.photoLeft"
                :photoTop="item2.photoTop"
                :showPhoto="item2.showPhoto"
                :shadow="item2.shadow ? true : false"
                :allIndex="allIndex"
                :dIndex="index"
                :debug="false"
                :disable="true"
                :fontFamily="item2.fontFamily"
                :textDecoration="item2.textDecoration"
                :textIndent="item2.textIndent"
                :photoRotate="item2.photoRotate"
                :writingMode="item2.writeMode"
                :lineHeight="item2.lineHeight"
                :fontWeight="item2.fontWeight"
                :fontStyle="item2.fontStyle"
                :textAlign="item2.textAlign"
                :type="item2.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :frameId="'main' + index + '_' + index2"
                :lockAspectRatio="item2.lockAspectRatio ? true : false"
                :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                :bImg2="item2.backImg2"
                :bRadius="item2.borderRadius"
                :fontColor="item2.fColor"
                :text="item2.textarea"
                :o="item2.opacity"
                :l="item2.lock ? true : false"
                dragHandle="false"
                :backColor="item2.bColor"
                :borderColor="item2.bordersColor"
                :borderLeft="item2.bLeft"
                :borderTop="item2.bTop"
                :borderRight="item2.bRight"
                :borderBottom="item2.bBottom"
                :borderStyle="item2.bStyle"
                :paddingLeft="item2.paddingLeft"
                :paddingTop="item2.paddingTop"
                :paddingRight="item2.paddingRight"
                :paddingBottom="item2.paddingBottom"
                :active="false"
                :fontSize="item2.fSize"
              ></vue-draggable-resizable>
            </div>
          </div>
        </vue-draggable-resizable>

        <vue-draggable-resizable
          v-if="dragsSelectIndexs.length > 1"
          ref="multiDrag"
          :w="multipleDrag.width"
          @handleUnlock="handleUnlock"
          :textShadow="multipleDrag.textShadow ? true : false"
          :h="multipleDrag.height"
          :x="multipleDrag.left"
          :y="multipleDrag.top"
          :r="multipleDrag.rotate"
          :z="multipleDrag.zIndex"
          :parent="true"
          :minWidth="12"
          :minHeight="12"
          :level="multipleDrag.level"
          :levelType="multipleDrag.levelType"
          :levelNum="multipleDrag.levelNum"
          :fontFamily="multipleDrag.fontFamily"
          @changeHeight="changeHeight"
          :photoScale="multipleDrag.photoScale"
          :photoLeft="multipleDrag.photoLeft"
          :photoTop="multipleDrag.photoTop"
          :showPhoto="multipleDrag.showPhoto"
          :shadow="multipleDrag.shadow ? true : false"
          :debug="false"
          :textDecoration="multipleDrag.textDecoration"
          :textIndent="multipleDrag.textIndent"
          :photoRotate="multipleDrag.photoRotate"
          :writingMode="multipleDrag.writeMode"
          :lineHeight="multipleDrag.lineHeight"
          :fontWeight="multipleDrag.fontWeight"
          :fontStyle="multipleDrag.fontStyle"
          :textAlign="multipleDrag.textAlign"
          :type="multipleDrag.type"
          :isConflictCheck="false"
          :snap="false"
          :snapTolerance="1"
          :lockAspectRatio="true "
          :backImg="
            multipleDrag.backgroundImg ? multipleDrag.backgroundImg : ''
          "
          :bImg2="multipleDrag.backImg2"
          :bRadius="multipleDrag.borderRadius"
          :draggable="multipleDrag.draggable"
          :fontColor="multipleDrag.fColor"
          :text="multipleDrag.textarea"
          :o="multipleDrag.opacity"
          :l="multipleDrag.lock ? true : false"
          :backColor="multipleDrag.bColor"
          :borderColor="multipleDrag.bordersColor"
          :borderLeft="multipleDrag.bLeft"
          :borderTop="multipleDrag.bTop"
          :borderRight="multipleDrag.bRight"
          :borderBottom="multipleDrag.bBottom"
          :borderStyle="multipleDrag.bStyle"
          :paddingLeft="multipleDrag.paddingLeft"
          :paddingTop="multipleDrag.paddingTop"
          :paddingRight="multipleDrag.paddingRight"
          :paddingBottom="multipleDrag.paddingBottom"
          :active="multipleDrag.active ? true : false"
          :fontSize="multipleDrag.fSize"
          :key="multipleDrag.ec_id"
          @pmoving="pmoving"
          @resizestop="resizingComStop"
          @movingStop="movingStop"
          @rotatingStop="rotating"
          @dragstop="draggingComStop"
          @dragging="draggingCom"
          @resizing= "resizingCom"
          @upTop="upTop(index)"
          @mouseEnter="listenMouseEnter"
          @mouserLeave="listenMouseLeave"
        >
          <div class="look" style="z-index: -1">
            <div
              class="wrap"
              :style="{
                width: multipleDrag.width + 'px',
                height: multipleDrag.height + 'px',
                transform: `scale(${multipleDrag.width /
                  multipleDrag.orignWidth},${multipleDrag.height /
                  multipleDrag.orignHeight})`,
                transformOrigin: '0px 0px',
              }"
            >
              <vue-draggable-resizable
                v-for="(item2, index2) in multipleDrag.coms"
                :key="'com' + index2"
                :w="item2.width"
                :h="item2.height"
                :x="item2.left"
                :y="item2.top"
                :r="item2.rotate"
                :z="item2.zIndex"
                :frameId="'frame' + '_' + index2"
                :photoScale="item2.photoScale"
                :photoLeft="item2.photoLeft"
                :photoTop="item2.photoTop"
                :showPhoto="item2.showPhoto"
                :shadow="item2.shadow ? true : false"
                :allIndex="allIndex"
                :dIndex="index2"
                :debug="false"
                :disable="true"
                :lineHeight="item2.lineHeight"
                :fontFamily="item2.fontFamily"
                :textDecoration="item2.textDecoration"
                :textIndent="item2.textIndent"
                :photoRotate="item2.photoRotate"
                :writingMode="item2.writeMode"
                :fontWeight="item2.fontWeight"
                :fontStyle="item2.fontStyle"
                :textAlign="item2.textAlign"
                :type="item2.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item2.lockAspectRatio ? true : false"
                :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                :bImg2="item2.backImg2"
                :bRadius="item2.borderRadius"
                :fontColor="item2.fColor"
                :text="item2.textarea"
                :o="item2.opacity"
                :l="item2.lock ? true : false"
                dragHandle="false"
                :backColor="item2.bColor"
                :borderColor="item2.bordersColor"
                :borderLeft="item2.bLeft"
                :borderTop="item2.bTop"
                :borderRight="item2.bRight"
                :borderBottom="item2.bBottom"
                :borderStyle="item2.bStyle"
                :paddingLeft="item2.paddingLeft"
                :paddingTop="item2.paddingTop"
                :paddingRight="item2.paddingRight"
                :paddingBottom="item2.paddingBottom"
                :active="false"
                :fontSize="item2.fSize"
              ></vue-draggable-resizable>
            </div>
          </div>
        </vue-draggable-resizable>
        <!--辅助线-->
        <!-- <span
          class="ref-line v-line"
          v-for="item in vLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength,
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in hLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength,
          }"
        /> -->
        <!--辅助线END-->
        <i
          v-if="activeIndex > -1 && drags[activeIndex].type != 4 &&
              dragsSelectIndexs.length < 2"
          :style="rotateStyle"
          class="rotatebox iconfont icon-xuanzhuan"
          @mousedown.stop.prevent="handleRotateTouchDown(null, $event)"
          @touchstart.stop.prevent="handleRotateDown(null, $event)"
          @touchend.stop.prevent="handleRotateUp"
        ></i>
        <div
          v-if="
            activeIndex > -1 &&
              dragsSelectIndexs.length < 2 &&
              (drags[activeIndex].type == 2 ||
                drags[activeIndex].type == 1 ||
                drags[activeIndex].type == 9)
          "
          :style="moveBoxStyle"
          class="moveBOX"
        >
          <img @click="fangda" src="../assets/fangda.png" alt="" />
          <img
            @mousedown.stop.prevent="handleMoveTouchDown(null, $event)"
            @touchstart.stop.prevent="handleMoveDown(null, $event)"
            @touchend.stop.prevent="handleRotateUp"
            src="../assets/yidong.png"
            alt=""
          />
          <img @click="suoxiao" src="../assets/suoxiao.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bottomChat">
      <div class="pagebox">
        <div
          @click="changePageNum(index)"
          v-for="(item, index) in pageObject"
          :key="index"
          class="item"
          :class="currentRowPage == index ? 'active' : ''"
        >
          {{
            item.type == 1
              ? "封"
              : item.type == 2
              ? parseInt(item.page_num)
              : "底"
          }}
        </div>
        <!-- <div @click="addPage" class="add-page">+</div> -->
      </div>
    </div>
    <div class="fixtop">
      <div @click="() => $router.back()" class="left">
        <a-page-header :title="pageTitle" @back="() => null" />
      </div>
      <div class="cz">
        <div @click="up()" class="cz-item">
          <i class="iconfont icon-shangyiyiceng"></i>
          <div class="name">上移一层</div>
        </div>
        <div @click="down()" class="cz-item">
          <i class="iconfont icon-xiayiyiceng"></i>
          <div class="name">下移一层</div>
        </div>
        <div @click="toTop()" class="cz-item">
          <i class="iconfont icon-control-top"></i>
          <div class="name">置顶</div>
        </div>
        <div @click="toBottom()" class="cz-item">
          <i class="iconfont icon-control-bottom"></i>
          <div class="name">置底</div>
        </div>
      </div>
      <div class="right">
        <div style="margin-right: 12px" class="network">
          <a-tooltip
            placement="bottom"
            :title="
              netWork > 1
                ? '网络状态良好'
                : netWork == 1
                ? '网络状态较差'
                : '网络已断开'
            "
          >
            <img
              style="width: 18px"
              v-if="netWork <= 1"
              src="../assets/online3.gif"
              alt=""
            />
            <img
              style="width: 18px"
              v-if="netWork > 1"
              src="../assets/online1.png"
              alt=""
            />
          </a-tooltip>
        </div>
        <div class="savebox flex-row">
          <a-icon :type="saveDraging ? 'loading' : 'check'" />
          <span>{{ saveDraging ? "上传中..." : "保存成功！" }}</span>
        </div>
        <div class="sizebox flex-row">
          <div class="name">缩放比列</div>
          <a-select style="width: 70px" v-model="sizeSelct" size="small">
            <a-select-option key="125" value="50">50%</a-select-option>
            <a-select-option key="75" value="75">75%</a-select-option>
            <a-select-option key="100" value="100">100%</a-select-option>
            <a-select-option key="125" value="125">125%</a-select-option>
            <a-select-option key="125" value="150">150%</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="left-tools">
      <div @mousedown="handleSelectSquire" class="item">
        <div class="type-squire"></div>
      </div>
      <div @mousedown="handleSelectCircle" class="item">
        <div class="type-circle"></div>
      </div>
      <div @mousedown="handleSelectLine" class="item">
        <div class="type-line"></div>
      </div>
    </div>
    <img v-if="priviewImg" class="priview-img" :src="priviewImg" alt="" />
    <div class="rightChat" @click="catchClick">
      <div class="tabbar">
        <div
          @click="changeTab(0)"
          @contextmenu="rightClick"
          class="tab-item"
          :class="tabIndex == 0 ? 'active' : ''"
        >
          属性
        </div>
        <div
          @click="changeTab(2)"
          class="tab-item"
          :class="tabIndex == 2 ? 'active' : ''"
        >
          素材
        </div>
        <!-- <div
          @click="changeTab(3)"
          class="tab-item"
          :class="tabIndex == 3 ? 'active' : ''"
        >
          文本框
        </div> -->

        <div
          @click="changeTab(4)"
          class="tab-item"
          :class="tabIndex == 4 ? 'active' : ''"
        >
          相框
        </div>
        <div
          @click="changeTab(5)"
          class="tab-item"
          :class="tabIndex == 5 ? 'active' : ''"
        >
          背景
        </div>
        <div
          @click="changeTab(6)"
          class="tab-item"
          :class="tabIndex == 6 ? 'active' : ''"
        >
          组合
        </div>
      </div>
      <div class="content">
        <div class="cell photo-box" v-if="tabIndex == 0">
          <div v-if="drags.length == 0" class="section">
            <div class="section-item">
              <div class="item-line">
                <div class="title">暂无组件</div>
              </div>
            </div>
          </div>
          <div v-if="drags.length > 0 && activeIndex > -1" class="section">
            <div class="section-item">
              <div class="item-line">
                <div class="title">元件属性</div>
                <i
                  @click="drags[activeIndex].lock = !drags[activeIndex].lock"
                  style="margin-right: 0"
                  class="iconfont"
                  :class="
                    drags[activeIndex].lock ? 'icon-suoding1' : 'icon-suo'
                  "
                ></i>
              </div>
            </div>
            <div class="section-item">
              <div class="item-line">
                <div class="cell">
                  <span class="name">X</span>
                  <a-input-number
                    v-model="drags[activeIndex].left"
                    controls-position="right"
                    :min="-500"
                    :max="1000"
                    type="number"
                    :disabled="drags[activeIndex].lock"
                  ></a-input-number>
                </div>
                <div class="cell">
                  <span class="name">Y</span>
                  <a-input-number
                    v-model="drags[activeIndex].top"
                    controls-position="right"
                    :min="-500"
                    :max="1000"
                    :disabled="drags[activeIndex].lock"
                  ></a-input-number>
                </div>
              </div>
              <div class="item-line">
                <div class="cell">
                  <span class="name">W</span>
                  <a-input-number
                    v-model="drags[activeIndex].width"
                    controls-position="right"
                    :min="12"
                    disabled
                    :max="1000"
                  ></a-input-number>
                </div>
                <div class="cell">
                  <span class="name">H</span>
                  <a-input-number
                    v-model="drags[activeIndex].height"
                    controls-position="right"
                    :min="12"
                    disabled
                    :max="1000"
                  ></a-input-number>
                </div>
              </div>
              <div class="item-line">
                <div class="cell">
                  <span class="name">R</span>
                  <a-input-number
                    v-model="drags[activeIndex].rotate"
                    controls-position="right"
                    :min="0"
                    :max="359"
                    :disabled="drags[activeIndex].lock"
                  ></a-input-number>
                </div>
                <div class="cell">
                  <span class="name" style="width: auto">比列锁定</span>
                  <i
                    @click="
                      drags[activeIndex].lockAspectRatio = !drags[activeIndex]
                        .lockAspectRatio
                    "
                    style="margin-right: 0"
                    class="iconfont"
                    :class="
                      drags[activeIndex].lockAspectRatio
                        ? 'icon-suoding1'
                        : 'icon-suo'
                    "
                  ></i>
                </div>
              </div>
            </div>
            <div class="section-item">
              <div
                class="item-line"
                :class="this.dragsSelectIndexs.length > 1 ? ' ' : 'dq_none'"
              >
                <span class="name" style="width: 70px">组件对齐</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-row>
                    <a-col
                      @click="dqdrags('left')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="左对齐">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_horizalign-left"
                          ></i>
                          <!-- <div class="name">左对齐</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                    <a-col
                      @click="dqdrags('right')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="右对齐">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_horizalign-right"
                          ></i>
                          <!-- <div class="name">右对齐</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                    <a-col
                      @click="dqdrags('top')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="顶对齐">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_verticalalign-top"
                          ></i>
                          <!-- <div class="name">顶对齐</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                    <a-col
                      @click="dqdrags('bottom')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="底对齐">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_verticalalign-bottom"
                          ></i>
                          <!-- <div class="name">底对齐</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                    <a-col
                      @click="dqdrags('horCenter')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="水平居中">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_horizalign-center"
                          ></i>
                          <!-- <div class="name">水平居中</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                    <a-col
                      @click="dqdrags('verCenter')"
                      style="cursor: pointer"
                      :span="4"
                    >
                      <a-tooltip title="垂直居中">
                        <div class="align-item">
                          <i
                            class="iconfont3 icon-jurassic_verticalalign-center"
                          ></i>
                          <!-- <div class="name">垂直居中</div> -->
                        </div>
                      </a-tooltip>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div v-if="!multipleDrag" class="section-item">
              <div class="item-line">
                <span class="name" style="width: 70px">透明度</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-slider v-model="drags[activeIndex].opacity"></a-slider>
                </div>
              </div>
            </div>
            <div v-if="!drags[activeIndex].lock && !multipleDrag" class="section-item">
              <div class="item-line">
                <span class="name2" style="width: 70px">组件</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-button type="primary" @click="copythisDrag"
                    >复制组件</a-button
                  >
                  <a-button
                    type="primary"
                    style="margin-left:10px"
                    @click="copythisDrag"
                    >粘贴组件</a-button
                  >
                </div>
              </div>
              <div class="item-line">
                <span class="name2" style="width: 70px"></span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-button @click="handleRemoveDrag">删除组件</a-button>
                  <a-button
                    v-if="
                      drags[activeIndex].type == 1 ||
                        drags[activeIndex].type == 2 ||
                        drags[activeIndex].type == 9
                    "
                    style="margin-left: 10px"
                    @click="previewFrame = true"
                    >更换相框</a-button
                  >
                </div>
              </div>
              <!-- <div class="item-line">
                <span class="name2" style="width: 70px"></span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-button @click="previewFrame = true">更换相框</a-button>
                </div>
              </div> -->
              <div v-if="drags[activeIndex].type != 5" class="item-line">
                <span class="name2" style="width: 70px">背景色</span>
                <div class="flex-1" style="padding-right: 20px">
                  <el-color-picker
                    v-model="drags[activeIndex].bColor"
                    show-alpha
                  >
                  </el-color-picker>
                </div>
                <div class="flex-1">
                  <a-button @click="cancelBcolor">清空</a-button>
                </div>
              </div>
              <div v-if="drags[activeIndex].type != 5" class="item-line">
                <span class="name2" style="width: 70px">边框色</span>
                <div class="flex-1" style="padding-right: 20px">
                  <el-color-picker
                    v-model="drags[activeIndex].bordersColor"
                    show-alpha
                  >
                  </el-color-picker>
                </div>
                <div class="flex-1">
                  <a-button @click="calcelbordersColor">清空</a-button>
                </div>
              </div>
              <div
                v-if="
                  drags[activeIndex].type == 1 ||
                    drags[activeIndex].type == 7 ||
                    drags[activeIndex].type == 9
                "
                class="item-line"
              >
                <span class="name2" style="width: 70px">圆角</span>
                <div class="flex-1" style="padding-right: 0px">
                  <a-input-number
                    v-model="drags[activeIndex].borderRadius"
                    controls-position="right"
                    :min="0"
                    :max="1000"
                    size="small"
                  ></a-input-number>
                </div>
              </div>

              <div v-if="drags[activeIndex].type != 5" class="item-line">
                <span class="name2" style="width: 70px"></span>
                <div class="flex-1" style="padding-right: 0px">
                  <div class="num-item" style="margin-bottom: 10px">
                    <div class="num-cell">
                      <i class="iconfont icon-jurassic_border-left"></i>
                      <a-input-number
                        v-model="drags[activeIndex].bLeft"
                        controls-position="right"
                        :min="0"
                        :max="359"
                        size="small"
                      ></a-input-number>
                    </div>
                    <div class="num-cell">
                      <i class="iconfont icon-jurassic_border-top"></i>
                      <a-input-number
                        v-model="drags[activeIndex].bTop"
                        controls-position="right"
                        :min="0"
                        :max="359"
                        size="small"
                      ></a-input-number>
                    </div>
                  </div>
                  <div class="num-item">
                    <div class="num-cell">
                      <i class="iconfont icon-jurassic_border-right"></i>
                      <a-input-number
                        v-model="drags[activeIndex].bRight"
                        controls-position="right"
                        :min="0"
                        :max="359"
                        size="small"
                      ></a-input-number>
                    </div>
                    <div class="num-cell">
                      <i class="iconfont icon-jurassic_border-bottom"></i>
                      <a-input-number
                        v-model="drags[activeIndex].bBottom"
                        controls-position="right"
                        :min="0"
                        :max="359"
                        size="small"
                      ></a-input-number>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="drags[activeIndex].type != 5" class="item-line">
                <span class="name2" style="width: 70px">边框样式</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-select
                    v-model="drags[activeIndex].bStyle"
                    placeholder="请选择"
                  >
                    <a-select-option label="实线" value="solid"
                      >实线
                    </a-select-option>
                    <a-select-option label="虚线" value="dashed">
                      虚线</a-select-option
                    >
                    <a-select-option label="点状" value="dotted"
                      >点状
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <!-- <div
                v-if="
                  drags[activeIndex].type != 0 && drags[activeIndex].type != 5
                "
                class="item-line"
              >
                <span class="name2" style="width: 70px">阴影</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-switch
                    @click="changeSwitch"
                    :checked="drags[activeIndex].shadow ? true : false"
                  >
                  </a-switch>
                </div>
              </div> -->
              <div
                v-if="
                  drags[activeIndex].type == 1 ||
                    drags[activeIndex].type == 2 ||
                    drags[activeIndex].type == 9
                "
                class="item-line"
              >
                <span class="name2" style="width: 70px">照片</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-button @click="calcelPhoto">去除照片</a-button>
                </div>
              </div>
            </div>
            <div
              v-if="!drags[activeIndex].lock && drags[activeIndex].type == 4 && !multipleDrag"
              class="section-item"
            >
              <div class="item-line">
                <span class="name2" style="width: 70px">评级颜色</span>
                <div class="flex-1" style="padding-right: 20px">
                  <el-color-picker
                    v-model="drags[activeIndex].fColor"
                    show-alpha
                  >
                  </el-color-picker>
                </div>
              </div>
              <div class="item-line">
                <span class="name2" style="width: 70px">评级类型</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-select
                    @change="changeLevelType"
                    v-model="drags[activeIndex].levelType"
                    style="width: 100%"
                  >
                    <a-select-option label="星星" :value="1"
                      >星星
                    </a-select-option>
                    <a-select-option label="打钩" :value="2">
                      打钩</a-select-option
                    >
                  </a-select>
                </div>
              </div>
              <div class="item-line">
                <span class="name2" style="width: 70px">图标大小</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-input-number
                    v-model="drags[activeIndex].fSize"
                    :min="12"
                  />
                </div>
              </div>
              <div v-if="drags[activeIndex].levelType == 2" class="item-line">
                <span class="name2" style="width: 70px">档位</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-select
                    v-model="drags[activeIndex].levelNum"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <a-select-option label="3档" :value="3"
                      >3档
                    </a-select-option>
                    <a-select-option
                      v-if="drags[activeIndex].levelType == 2"
                      label="4档"
                      :value="4"
                    >
                      4档</a-select-option
                    >
                  </a-select>
                </div>
              </div>
            </div>
            <div v-if="drags[activeIndex].type == 5 && !multipleDrag" class="section-item">
              <div class="item-line">
                <div class="section">
                  <div
                    class="item"
                    style="
                      height: 40px;
                      padding: 4px;
                      box-sizing: border-box;
                      margin-bottom: 20px;
                    "
                  >
                    <a-row :gutter="[10, 10]">
                      <a-col :span="24">
                        <div
                          @click="handleChangeFamily()"
                          :style="{ fontFamily: drags[activeIndex].fontFamily }"
                          style="
                            border: 1px solid #eee;
                            height: 40px;
                            text-align: center;
                            line-height: 40px;
                            white-space: nowrap;
                            text-align: center;
                            font-size: 14px;
                            position: relative;
                            cursor: pointer;
                          "
                        >
                          {{
                            drags[activeIndex].fontFamily
                              ? drags[activeIndex].fontFamily
                              : "默认字体"
                          }}
                        </div>
                        <a-row v-show="familyMask" class="selectFamily">
                          <a-col
                            v-for="(item, index) in fonts"
                            :key="index"
                            :span="24"
                          >
                            <div
                              @click="changeFamily(item)"
                              :style="{ fontFamily: item }"
                              style="
                                border: 1px solid #eee;
                                height: 40px;
                                text-align: center;
                                line-height: 40px;
                                white-space: nowrap;
                                text-align: center;
                                font-size: 14px;
                                margin: 2px 0;
                              "
                            >
                              {{ item }}
                            </div>
                          </a-col>
                        </a-row>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="item">
                    <div class="row">
                      <div
                        @click="changeB"
                        class="label"
                        :class="
                          drags[activeIndex].fontWeight == 'bold'
                            ? 'active'
                            : ''
                        "
                      >
                        <b>B</b>
                      </div>
                      <div
                        @click="changeI"
                        class="label"
                        :class="
                          drags[activeIndex].fontStyle == 'italic'
                            ? 'active'
                            : ''
                        "
                      >
                        <em>I</em>
                      </div>
                      <div
                        @click="changeU"
                        class="label"
                        :class="
                          drags[activeIndex].textDecoration == 'underline'
                            ? 'active'
                            : ''
                        "
                      >
                        <u> U </u>
                      </div>
                      <div
                        @click="changeS"
                        class="label"
                        :class="
                          drags[activeIndex].textDecoration == 'line-through'
                            ? 'active'
                            : ''
                        "
                      >
                        <s>S</s>
                      </div>
                      <div @click="clear" class="label">清除</div>
                    </div>
                    <div class="row">
                      <div class="col-3">
                        <div
                          @click="drags[activeIndex].textAlign = 'left'"
                          :class="
                            drags[activeIndex].textAlign == 'left' ||
                            !drags[activeIndex].textAlign
                              ? 'active'
                              : ''
                          "
                          class="cell"
                        >
                          <i class="miconfont icon-align-left"></i>
                        </div>
                        <div
                          @click="drags[activeIndex].textAlign = 'center'"
                          :class="
                            drags[activeIndex].textAlign == 'center'
                              ? 'active'
                              : ''
                          "
                          class="cell"
                        >
                          <i class="miconfont icon-align-center"></i>
                        </div>
                        <div
                          @click="drags[activeIndex].textAlign = 'right'"
                          :class="
                            drags[activeIndex].textAlign == 'right'
                              ? 'active'
                              : ''
                          "
                          class="cell"
                        >
                          <i class="miconfont icon-align-right"></i>
                        </div>
                        <div
                          @click="drags[activeIndex].textAlign = 'justify'"
                          :class="
                            drags[activeIndex].textAlign == 'justify'
                              ? 'active'
                              : ''
                          "
                          class="cell"
                        >
                          <i class="miconfont icon-menu"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--缩进-->
                  <div class="item">
                    <div class="row">
                      <div @click="addTextIndent" class="label outline">
                        <i
                          style="font-size: 22px"
                          class="miconfont icon-indent"
                        ></i>
                      </div>
                      <div @click="decTextIndent" class="label outline">
                        <i
                          style="font-size: 22px"
                          class="miconfont icon-outdent"
                        ></i>
                      </div>
                      <div class="label outline">
                        <a-row>
                          <a-col :span="24" style="text-align: center">
                            <div style="margin-bottom: 5px">字体颜色</div>
                            <el-color-picker
                              v-model="drags[activeIndex].fColor"
                            ></el-color-picker>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="familyMask"
                    @click="familyMask = false"
                    class="mask2"
                  ></div>
                  <!--字号-->
                  <div class="item">
                    <div class="row">
                      <div
                        @click="changeFSize(58.667)"
                        :class="
                          drags[activeIndex].fSize == 58.667 ? 'active' : ''
                        "
                        class="label"
                      >
                        初号
                      </div>
                      <div
                        @click="changeFSize(48)"
                        :class="drags[activeIndex].fSize == 48 ? 'active' : ''"
                        class="label"
                      >
                        小初号
                      </div>
                      <div
                        @click="changeFSize(32)"
                        :class="drags[activeIndex].fSize == 32 ? 'active' : ''"
                        class="label"
                      >
                        小一号
                      </div>
                      <div
                        @click="changeFSize(29.333)"
                        :class="
                          drags[activeIndex].fSize == 29.333 ? 'active' : ''
                        "
                        class="label"
                      >
                        二号
                      </div>
                      <div
                        @click="changeFSize(24)"
                        :class="drags[activeIndex].fSize == 24 ? 'active' : ''"
                        class="label"
                      >
                        小二号
                      </div>
                    </div>
                    <div class="row">
                      <div
                        @click="changeFSize(21.333)"
                        :class="
                          drags[activeIndex].fSize == 21.333 ? 'active' : ''
                        "
                        class="label"
                      >
                        三号
                      </div>
                      <div
                        @click="changeFSize(18.667)"
                        :class="
                          drags[activeIndex].fSize == 18.667 ? 'active' : ''
                        "
                        class="label"
                      >
                        四号
                      </div>
                      <div
                        @click="changeFSize(16)"
                        :class="drags[activeIndex].fSize == 16 ? 'active' : ''"
                        class="label"
                      >
                        小四号
                      </div>
                      <div
                        @click="changeFSize(14)"
                        :class="drags[activeIndex].fSize == 14 ? 'active' : ''"
                        class="label"
                      >
                        五号
                      </div>
                      <div
                        @click="changeFSize(12)"
                        :class="drags[activeIndex].fSize == 12 ? 'active' : ''"
                        class="label"
                      >
                        小五号
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="drags[activeIndex].type == 5 && !drags[activeIndex].lock && !multipleDrag"
              class="section-item"
            >
              <div class="item-line">
                <span class="name2" style="width: 70px">内容</span>
              </div>
              <div class="item-line">
                <span class="name2" style="width: 70px">文字行高</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-input
                    :disabled="drags[activeIndex].lineHeightAutoSize == 1"
                    class="input"
                    v-model="drags[activeIndex].lineHeight"
                    type="number"
                  >
                  </a-input>
                </div>
              </div>
              <div class="item-line">
                <span class="name2" style="width: 70px"></span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-checkbox
                    @change="onChangeAutoSize"
                    :checked="drags[activeIndex].lineHeightAutoSize == 1"
                  >
                    自动计算行高
                  </a-checkbox>
                </div>
              </div>
              <!-- <div class="item-line">
                <span class="name2" style="width: 70px">排列方式</span>
                <div class="flex-1" style="padding-right: 20px">
                  <a-select
                    v-model="drags[activeIndex].fontStyle"
                    placeholder="请选择"
                    style="width:120px"
                  >
                    <a-select-option label="横排" value="horizontal-tb"
                      >横排</a-select-option
                    >
                    <a-select-option label="竖排-从左向右" value="vertical-lr">
                      竖排-从左向右</a-select-option
                    >
                  </a-select>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="cell photo-box"
          onselectstart="return false"
          v-if="tabIndex == 2"
        >
          <div class="searchbox" style="display: block;">
            <a-row>
              <a-col :span="12">
                <a-select
                  style="width:100%;"
                  v-model="pasterType"
                  @change="changePasterType"
                >
                  <a-select-option :value="1">通用素材</a-select-option>
                  <a-select-option :value="2">专属素材</a-select-option>
                  <a-select-option :value="3">个人素材</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12" style="padding-right: 10px;">
                <a-select
                  style="width:100%;margin-left:10px;"
                  v-model="pasterClassId"
                  @change="changePasterClassId"
                >
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in pasterClass"
                    :key="index"
                    :value="item.pc_id"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>

            <a-input-search
              style="margin-top:10px"
              placeholder="搜索名称"
              v-model="pasterTag"
              enter-button
              @search="onSearchimgs"
            />
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleSelectText()"
              @click="addText()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleStarSelect()"
              @click="addStar()"
              class="look"
            >
              <img class="img" :src="require('../assets/rant.png')" alt="" />
            </div>
          </div>
          <div v-for="(item, index) in imgs" :key="index" class="back-item">
            <div v-if="pasterType != 3" class="back">
              <img
                ref="paster"
                @mousedown="handleSelectPhotoUrl(item.paster, index)"
                @mouseup="mouseUpPhoto(item.paster)"
                @click="addPhoto2(item.paster)"
                class="img"
                :src="item.paster"
                alt=""
              />
            </div>
            <div v-if="pasterType == 3" class="back">
              <img
                ref="paster"
                @mousedown="handleSelectPhotoUrl(item.img_personal)"
                @mouseup="mouseUpPhoto(item.img_personal)"
                @click="addPhoto2(item.img_personal)"
                class="img"
                :src="item.img_personal"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              show-quick-jumper
              show-less-items
              size="small"
              :defaultPageSize="16"
              :current="imgPage.current_page"
              :total="imgPage.total"
              @change="onChangeImgPage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 3">
          <div class="photo-item">
            <div
              @mousedown="handleSelectText()"
              @click="addText()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
            <div class="name">文本框</div>
          </div>
          <div class="photo-item">
            <div
              @mousedown="handleStarSelect()"
              @click="addStar()"
              class="look"
            >
              <img class="img" :src="require('../assets/biaoti.png')" alt="" />
            </div>
            <div class="name">文本框</div>
          </div>
        </div>
        <div
          class="cell photo-box"
          onselectstart="return false"
          v-if="tabIndex == 4"
        >
          <div class="searchbox">
            <a-select
              style="width:120px;margin-left:10px"
              v-model="frameType"
              @change="changeFrameType"
            >
              <a-select-option :value="1">通用相框</a-select-option>
              <a-select-option :value="2">专属相框</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="frameTag"
              enter-button
              @search="onSearchphotos"
            />
          </div>
          <div
            v-for="(item, index) in suireList"
            :key="'squire' + index"
            class="photo-item"
          >
            <div
              @mousedown="handleAddSquire(index)"
              @click="addSquire(0)"
              class="look"
              draggable="true"
              :style="{ border: '1px solid #eee', backgroundColor: '#eeeeee' }"
            >
              <div
                :style="{
                  width: '100%',
                  height: (item.height * 100) / item.width + 'px',
                  paddingLeft: item.paddingLeft + 'px',
                  paddingTop: item.paddingTop + 'px',
                  paddingRight: item.paddingRight + 'px',
                  paddingBottom: item.paddingBottom + 'px',
                  backgroundColor: item.bColor,
                  borderRadius: item.borderRadius + 'px',
                  borderColor: item.bordersColor,
                  borderStyle: item.bStyle,
                  borderTopWidth: item.bTop + 'px',
                  borderBottomWidth: item.bBottom + 'px',
                  borderLeftWidth: item.bLeft + 'px',
                  borderRightWidth: item.bRight + 'px',
                }"
              ></div>
            </div>
          </div>
          <div v-for="(item, index) in photos" :key="index" class="photo-item">
            <div
              @mousedown="handleSelectPhoto2(item, index)"
              @click="addPhoto(item)"
              :style="item"
              class="look"
            >
              <img
                ref="frame"
                :style="{ borderRadius: item.borderRadius }"
                class="img"
                :src="item.backgroundImg"
                alt=""
              />
              <img
                v-if="item.backImg2"
                class="img2"
                :src="item.backImg2"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              :defaultPageSize="14"
              :current="photoPage.current_page"
              :total="photoPage.total"
              show-quick-jumper
              show-less-items
              @change="onChangeframePage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 5">
          <div class="searchbox">
            <a-select
              style="width:120px;margin-left:10px"
              v-model="backgroundType"
              @change="changeBackType"
            >
              <a-select-option :value="1">通用背景</a-select-option>
              <a-select-option :value="2">专属背景</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="backgroundTag"
              enter-button
              @search="onSearchbacks"
            />
          </div>
          <a-empty
            description="暂无内容"
            v-show="backs.length == 0"
            style="margin-top:10px"
          />
          <div v-for="(item, index) in backs" :key="index" class="back-item">
            <div class="back">
              <img
                @click="changeBack(item.background)"
                class="img"
                :src="item.background"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              :defaultPageSize="12"
              show-quick-jumper
              show-less-items
              :current="backPage.current_page"
              :total="backPage.total"
              @change="onChangeBackPage"
            />
          </div>
        </div>
        <div class="cell" onselectstart="return false" v-if="tabIndex == 6">
          <div class="searchbox">
            <a-select
              v-model="buildUpType"
              style="width:120px;margin-left:10px"
              @change="changeBuildType"
            >
              <a-select-option :value="1">通用组合</a-select-option>
              <a-select-option :value="2">专属组合</a-select-option>
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              enter-button
              v-model="buildUpTag"
              @search="onSearchbuildup"
            />
          </div>
          <a-empty
            description="暂无内容"
            v-show="buildUp.length == 0"
            style="margin-top:10px"
          />
          <div
            v-for="(build, index) in buildUp"
            :key="index"
            @mousedown="handleSelectCombination($event, index)"
              @mouseup="handleEndMovecom"
            class="build-item"
            draggable="true"
          >
            <div
              ref="comItem"
              class="look"
            >
              <div
                class="wrap"
                :style="{
                  width: build.width + 'px',
                  height: build.height + 'px',
                  transform: `scale(${build.scale})`,
                }"
              >
                <vue-draggable-resizable
                  v-for="(item, index2) in build.coms"
                  :key="index2"
                  :w="item.width"
                  :h="item.height"
                  :x="item.left"
                  :y="item.top"
                  :r="item.rotate"
                  :z="item.zIndex"
                  :frameId="'buildup' + index + '_' + index2"
                  :photoScale="item.photoScale"
                  :photoLeft="item.photoLeft"
                  :photoTop="item.photoTop"
                  :showPhoto="item.showPhoto"
                  :shadow="item.shadow ? true : false"
                  :allIndex="allIndex"
                  :dIndex="index"
                  :debug="false"
                  :disable="true"
                  :lineHeight="item.lineHeight"
                  :fontWeight="item.fontWeight"
                  :fontStyle="item.fontStyle"
                  :textAlign="item.textAlign"
                  :type="item.type"
                  :isConflictCheck="false"
                  :snap="true"
                  :snapTolerance="1"
                  :lockAspectRatio="item.lockAspectRatio ? true : false"
                  :backImg="item.backgroundImg ? item.backgroundImg : ''"
                  :bImg2="item.backImg2"
                  :bRadius="item.borderRadius"
                  :fontColor="item.fColor"
                  :text="item.textarea"
                  :o="item.opacity"
                  :l="item.lock ? true : false"
                  dragHandle="false"
                  :backColor="item.bColor"
                  :borderColor="item.bordersColor"
                  :borderLeft="item.bLeft"
                  :borderTop="item.bTop"
                  :borderRight="item.bRight"
                  :borderBottom="item.bBottom"
                  :borderStyle="item.bStyle"
                  :paddingLeft="item.paddingLeft"
                  :paddingTop="item.paddingTop"
                  :paddingRight="item.paddingRight"
                  :paddingBottom="item.paddingBottom"
                  :active="false"
                  :fontSize="item.fSize"
                ></vue-draggable-resizable>
              </div>
            </div>
            <!-- <div class="name">{{ index }}</div> -->
          </div>
          <div class="pagebox">
            <a-pagination
              size="small"
              show-quick-jumper
              show-less-items
              :defaultPageSize="15"
              :current="buildUpPage.current_page"
              :total="buildUpPage.total"
              @change="onChangeBuildPage"
            />
          </div>
        </div>
      </div>
      <a-modal
        v-model="showTypeSelect"
        title="选择新增内容"
        centered
        width="800px"
        @ok="confirmPageType"
      >
        <a-radio-group
          v-show="!pageObject || pageObject.length == 0"
          v-model="addType"
          @change="changeAddtype"
          style="margin-bottom: 20px"
        >
          <a-radio key="0" value="">页面</a-radio>
          <a-radio v-if="plate_type == 3" key="3" value="3">封面模板</a-radio>
          <a-radio v-if="plate_type == 1" key="1" value="1">完整模板</a-radio>
        </a-radio-group>

        <a-select
          v-if="!addType"
          style="width: 100%"
          v-model="typeSelect"
          @change="changePage"
        >
          <a-select-option
            v-for="item in typeSelector"
            :key="item.type"
            :value="item.type"
            >{{ item.name }}</a-select-option
          >
        </a-select>

        <div v-if="addType" class="plate">
          <div class="search">
            <a-input-search
              placeholder="输入模板名称搜索"
              v-model="plate_name"
              enter-button
              @search="onPlateSearch"
            ></a-input-search>
          </div>
          <a-empty
            description="暂无内容"
            style="margin-top: 20px"
            v-show="plateList.length == 0"
          />
          <div v-show="plateList.length > 0" class="plate-list">
            <div
              @click="selectPlate(index)"
              :class="item.select ? 'select' : ''"
              v-for="(item, index) in plateList"
              :key="index"
              :style="{
                backgroundImage: 'url(' + item.cover + ')',
                backgroundSize: 'contain',
              }"
              class="cell"
            >
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
          <div
            v-show="plateList.length > 0"
            class="page"
            style="clear: both; overflow: hidden; margin-top: 20px"
          >
            <a-pagination
              show-quick-jumper
              show-less-items
              size="small"
              style="float: right"
              :current="currentPage"
              :total="plateTotal"
              :defaultPageSize="10"
              @change="onChangePlatePage"
            />
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="previewFrame"
        width="810px"
        title="更换相框"
        :footer="null"
        @cancel="previewFrame = false"
        centered
      >
        <div class="frameModal" style="padding: 20px">
          <div class="searchbox">
            <a-select
              style="width: 120px; margin-left: 10px"
              v-model="photoId2"
              @change="changePhotoId2"
            >
              <a-select-option
                v-for="(item, index) in schoolIds"
                :key="index"
                :value="item.id"
                >{{ item.school_title }}</a-select-option
              >
            </a-select>
            <a-input-search
              placeholder="搜索名称"
              v-model="photoTag2"
              enter-button
              @search="onSearchPhoto2"
            />
          </div>
          <a-empty
            description="暂无内容"
            v-show="photos2.length == 0"
            style="margin-top: 10px; width: 100%"
          />
          <div
            v-for="(item, index) in photos2"
            @click="changeFrame(item)"
            :key="index"
            class="photo-item"
          >
            <div :style="item" class="look">
              <img
                ref="frame"
                :style="{ borderRadius: item.borderRadius }"
                class="img"
                :src="item.backgroundImg"
                alt=""
              />
              <img
                v-if="item.backImg2"
                class="img2"
                :src="item.backImg2"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
          <div v-if="photoPage2" class="pagebox">
            <a-pagination
              show-quick-jumper
              show-less-items
              size="small"
              :defaultPageSize="18"
              :current="photoPage2.current_page"
              :total="photoPage2.total"
              @change="onChangePhotoPage2"
            />
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="eiditVisible"
        width="800px"
        @ok="confirmEdit"
        centered
        @cancel="handleCancelEdit"
      >
        <div style="padding: 20px; height: 400px">
          <quill-editor
            v-model="editText"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
          >
          </quill-editor>
        </div>
      </a-modal>
    </div>
    <div v-if="tabIndex != 1" class="rightfix">
      <div @click="showSaveTpl = true" class="pull-p">
        <img src="../assets/logo4.png" alt="" />
        <span>另存模板</span>
      </div>
      <div @click="handlemovePage" class="pull-p" style="background: #e73a36;">
        <img src="../assets/logo7.png" alt="" />
        <span>迁移至本学期模版</span>
      </div>
      <!-- <div
        @click="handleRebackPage"
        class="pull-p"
        style="background: #e73a36;"
      >
        <img src="../assets/logo7.png" alt="" />
        <span>还原此页</span>
      </div> -->
      <a-modal
        :visible="showSaveTpl"
        centered
        title="复制此模板"
        :mask="true"
        @cancel="showSaveTpl = false"
        @ok="handleSaveToTpl"
        :confirm-loading="confirmLoding"
        :closable="true"
      >
        <div class="uploadstate">
          <a-input
            v-model="tplName"
            style="margin-bottom: 10px;"
            placeholder="请输入模板名称"
          ></a-input>
        </div>
      </a-modal>
    </div>
    <div v-if="fixBtnLeft > 0" class="fixbtn" :style="leftBtnStyle">
      <div class="flex-row">
        <div @click="cancelStep" alt="ctrl+z" class="item">
          <a-tooltip placement="bottom">
            <template #title>
              <span>ctrl+z</span>
            </template>
            <a-icon
              :style="{ fontSize: '28px', color: '#1890ff' }"
              type="swap-left"
            />
            <div class="name">撤销</div>
          </a-tooltip>
        </div>
        <div
          @click="nextStep"
          alt="ctrl+shift+z"
          class="item"
          style="margin-left: 16px"
        >
          <a-tooltip placement="bottom">
            <template #title>
              <span>ctrl+shift+z</span>
            </template>
            <a-icon
              :style="{ fontSize: '28px', color: '#1890ff' }"
              type="swap-right"
            />
            <div class="name">前进</div>
          </a-tooltip>
        </div>
      </div>
      <a-button @click="savePlateContent2" type="primary">保存此页</a-button>
      <!-- <a-button @click="delPlateContent" type="default">删除此页</a-button> -->
    </div>

    <a-modal
      v-if="currentRowPage > -1"
      :visible="showfenPage"
      centered
      title="内容迁移"
      :mask="true"
      width="700px"
      @cancel="showfenPage = false"
      @ok="handlefenPage"
      :confirm-loading="moveLoding"
      :closable="true"
    >
      <div class="fenpage-modal">
        <div class="head">
          <img src="../assets/log2.png" alt="" />
          <div class="right">
            <div class="title">内容迁移</div>
            <div class="tip">
              将<span>{{
                pageObject[currentRowPage].type == 1
                  ? "封面"
                  : pageObject[currentRowPage].type == 2
                  ? parseInt(pageObject[currentRowPage].page_num)
                  : "封底"
              }}</span
              >页迁移给页面
            </div>
          </div>
        </div>
        <div class="student">
          <a-radio-group v-model="moveId" @change="onChangeMove">
            <a-row>
              <a-col v-for="(item, index) in pageObject2" :key="index" :sm="6">
                <div class="item">
                  <a-radio :value="item.stc_id">
                    {{
                      item.type == 1
                        ? "封面"
                        : item.type == 2
                        ? "第" + parseInt(item.page_num) + "页"
                        : "封底"
                    }}
                  </a-radio>
                </div>
              </a-col>
            </a-row>
          </a-radio-group>
        </div>
        <!-- <div @click="selectAll" class="select">
            {{!selectAllState ? '全选' : '取消全选'}}
          </div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import axios from "axios";
import { api } from "../api/api-tpl.js";
import { mapState } from "vuex";
import _ from "lodash";
import * as Quill from "vue-quill-editor";
import { getCoordinate } from "../utils/fns.js";

import html2canvas from "html2canvas";
import { addQuillTitle } from "../js/quill-title.js";
function getBlob(canvas) {
  // 获取blob对象
  var data = canvas.toDataURL("image/png", 1);
  data = data.split(",")[1];
  data = window.atob(data);
  var ia = new Uint8Array(data.length);
  for (var i = 0; i < data.length; i++) {
    ia[i] = data.charCodeAt(i);
  }

  return new Blob([ia], {
    type: "image/jpeg",
  });
}
export default {
  name: "app",
  components: {
    VueDraggableResizable,
  },
  data() {
    return {
      moveLoding:false,
      moveId: "",
      pageTitle: "",
      backgroundTag: "",
      search: "",
      pasterClass: [],
      pasterClassId: "",
      frameTag: "",
      frameTag: "",
      frameType: 1,
      frameType2: 1,
      buildUpType: 1,
      pasterType: 1,
      backgroundType: 1,
      buildUpTag: "",
      pasterTag: "",
      editList: [],
      albumList: [],
      picturePage: null,
      pageLists: [],
      currentBuild: 1,
      currentPaster: 1,
      currentPhoto: 1,
      currentBack: 1,
      currentFrame: 1,
      frameTag2: "",
      currentFrame2: 1,
      currentPicture: 1,
      pageModal: false,
      buildUp: [],
      buildUpPage: null,
      showfenPage: false,
      previewFrame: false,
      showSaveTpl: false,
      tplName: "",
      selectXY: {
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0,
      },
      stars: {
        left: null,
        top: null,
        width: 200,
        height: 38,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: "#ff6d2c",
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        borderRadius: 0,
        type: 4,
        name: "评级",
        lineHeight: "1.6",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        levelNum: 3,
        levelType: 1,
        level: 2,
      },
      multipleDrag: {
        left: null,
        top: null,
        width: 240,
        height: 180,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#cccccc",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#ffffff",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        type: 9,
        name: "方块一",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        borderRadius: 0,
        coms: [],
      },
      selectHeight: 0,
      cover_size: [],
      showCanvasImg: false,
      editContent: "",
      plate_type: 1,
      eiditVisible: false,
      editText: "",
      addType: "",
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [],
        },
      },
      step: -1,
      sizeSelct: 100,
      saveDraging: false,
      comHtml: null,
      showTypeSelect: false,
      typeSelector: [
        { type: 1, name: "封面" },
        { type: 2, name: "内页" },
        { type: 3, name: "封底" },
      ],
      activeIndex: -1,
      drags: [],
      schoolIds: null,
      vLine: [],
      hLine: [],
      tabIndex: 0,
      confirmLoding:false,
      pageObject2: [],
      imgs: [
        { url: require("../assets/img01.png"), name: "背景1" },
      ],
      random: (Math.random() + 100).toFixed(2),
      suireList: [
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
      ],
      texts: {
        left: null,
        top: null,
        width: 200,
        height: 28,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 5,
        name: "文字框",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      },
      dragsSelectIndexs: [],
      photoPage: null,
      photoPage2: null,
      imgPage: null,
      backPage: null,
      photos: [],
      photos2: [],
      pictures: [],
      backs: [],
      typeSelect: 2,
      currentBuild: 1,
      currentBuild2: 1,
      currentImg: 1,
      currentPhoto: 1,
      currentPhoto2: 1,
      currentBack: 1,
      api: api,
      fixBtnLeft: 0,
      buildUp: [],
      buildUpPage: null,
      backgroundImage: "",
      allIndex: 0,
      wrapperWidth: 400,
      mouseIn: [],
      selectImg: "",
      maxPage: 0,
      selectPhoto: null,
      pageObject: null,
      selectPageType: 2,
      currentRowPage: -1,
      plateContent: null,
      czHistory: [],
      originDrags: [],
      ComIndex: -1, // 拖动的组合
      bodyTranslateX: 0,
      bodyTranslateY: 0,
      leftChatMouseStateMove: false,
      uid: "",
      htmlUrl: "",
      plate_name: "",
      currentPage: 1,
      plateList: [],
      plateTotal: 0,
      downDrags: [],
      base64State: false,
      photoId: -1,
      photoId2: -1,
      backId: -1,
      pasterId: -1,
      buildId: -1,
      photoTag: "",
      photoTag2: "",
      pasterTag: "",
      backTag: "",
      buildTag: "",
      paster_classIds: [],
      paster_class: "",
      moveBoxRight: 0,
      moveBoxTop: 0,
      moveBoxRotate: 0,
      rotateStyles: { left: 0, top: 0 },
      priviewImg: "",
      familyMask: false,
      keyDown: {
        shiftKey: false,
        ctrlKey: false,
      },
      studentList: [],
      selectAllState: false,
    };
  },
  mounted() {
    var that = this;
    document.ondragover = function(e) {
      e.preventDefault();
    };
    this.$refs["body"].addEventListener(
      "mouseenter",
      (e) => {
        this.mouseEnterBody = true;
      },
      true
    );
    this.$refs["body"].addEventListener(
      "mouseleave",
      (e) => {
        this.mouseEnterBody = false;
      },
      true
    );
    this.$refs["body"].addEventListener("drop", (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (!this.pageObject || this.pageObject.length == 0) {
        this.$message.error("请先添加页码");
        this.ComIndex = -1;
        this.selectPhoto = null;
        return false;
      }
      if (!this.backgroundImage) {
        this.$message.error("请先添加背景图");
        this.ComIndex = -1;
        this.selectPhoto = null;
        return false;
      }
      if (this.selectImg) {
        setTimeout(() => {
          this.selectImg = "";
        }, 40);
      } else if (this.selectPhoto || this.ComIndex > -1) {
        this.addDrag(e);
      }
    });
    this.$refs["app"].addEventListener("drop", (e) => {
      setTimeout(() => {
        this.ComIndex = -1;
        this.selectPhoto = null;
        this.selectImg = "";
      }, 400);
    });
    setTimeout(() => {
      this.allIndex = this.drags.length;
    }, 1000);
    var that = this;
    document.onerror = function(e) {};
    this.$refs["leftChat"].addEventListener("mousedown", this.listenMouseDown);
    this.$refs["leftChat"].addEventListener("mouseup", () => {
      this.$refs["leftChat"].removeEventListener(
        "mousemove",
        this.listenMouseMove
      );
    });
    this.$refs["leftChat"].addEventListener("mousedown", (e) => {
      this.familyMask = false;
      this.dragsSelectIndexs = [];
    });
    this.$refs["body"].addEventListener("mousedown", (e) => {
      e.stopPropagation();
    });
    document.onkeydown = function(e) {
      var e = e || event;
      var currKey = e.keyCode || e.which || e.charCode;
      if (currKey == 32) {
        that.leftChatMouseStateMove = true;
      }

      if (e.shiftKey) {
        that.keyDown.shiftKey = true;
        if (that.multipleDrag) {
          that.multipleDrag.zIndex = 0;
        }
      }

      if (e.ctrlKey) {
        that.keyDown.ctrlKey = true;
        
      }


      if (e.ctrlKey && e.key == '-') {
        //禁用ctrl + a 功能
        that.sizeSelct -= 10
        e.preventDefault();
        return false;
      }

      if (e.ctrlKey && e.key == '=') {
        //禁用ctrl + a 功能
        that.sizeSelct += 10
        e.preventDefault();
        return false;
      }
      if (e.shiftKey) {
        that.keyDown.shiftKey = true;
      }
    };
    document.onkeyup = function(e) {
      console.log(e)
      that.keyDown.shiftKey = false;
      that.keyDown.ctrlKey = false;
      that.leftChatMouseStateMove = false;
      if (that.multipleDrag && e.shiftKey == false) { 
        that.multipleDrag.zIndex = 1000;
      }
      var e = e || event;
      var currKey = e.keyCode || e.which || e.charCode;
      if (e.ctrlKey && window.event.keyCode == 65) {
        // 禁用ctrl + a 功能
        return false;
      }
      if (e.ctrlKey && window.event.keyCode == 90 && !e.shiftKey) {
        that.cancelStep();
        return false;
      }
      if (e.ctrlKey && window.event.keyCode == 71) {
        that.addCom();
        return false;
      }
      if (e.ctrlKey && e.shiftKey && window.event.keyCode == 90) {
        that.nextStep();
        return false;
      }
      if (e.ctrlKey && window.event.keyCode == 67) {
        if (that.eiditVisible) {
          that.copyDrag = null;
          return false;
        }

        console.log(that.copyDrag,'11')
        if (that.dragsSelectIndexs && that.dragsSelectIndexs.length > 1) {
          that.copyDrag = [];
          that.dragsSelectIndexs.forEach((dragIndex) => {
            that.copyDrag.push(_.cloneDeep(that.drags[dragIndex]) );
          });
          console.log(that.copyDrag)
          return;
        }
        if (that.activeIndex > -1) {
          that.copyDrag = _.cloneDeep(that.drags[that.activeIndex]);
          delete that.copyDrag.estc_id;
          delete that.copyDrag.stc_id;
          delete that.copyDrag.st_id;
          console.log(that.copyDrag)
        }
      }
      if (e.ctrlKey && window.event.keyCode == 86) {
        console.log(that.copyDrag)
        if (that.copyDrag && that.copyDrag.length > 1) {
          console.log(that.copyDrag,'多选')
          for (let i = 0; i < that.copyDrag.length; i++) {
            const drag = _.cloneDeep(that.copyDrag[i]) ;
            delete drag.estc_id
            delete drag.stc_id
            delete drag.st_id
            drag.key = that.random + 1;
            that.random += 1;
            that.drags = [...that.drags, drag];
            that.drags.forEach((arr, index) => {
              arr.active = false;
              arr.draggable = false;
              if (index == that.drags.length - 1) {
                arr.active = true;
                arr.draggable = true;
                arr.zIndex = that.drags.length - 1;
              }
              return arr;
            });
            that.allIndex = that.drags.length;
            that.selectPhoto = null;
            that.ComIndex = -1;
            that.czHistory = [
              ...that.czHistory,
              { type: "adddrag", index: null, detail: drag },
            ];
            that.originDrags = _.cloneDeep(that.drags);
          }
          that.savePlateContent();
          return 
        }

        if (that.copyDrag) {
          var drag = _.cloneDeep(that.copyDrag);
          // drag.left += 10;
          // drag.top += 10;
          drag.key = that.random + 1;
          that.random += 1;
          that.drags = [...that.drags, drag];
          that.drags.forEach((arr, index) => {
            arr.active = false;
            arr.draggable = false;
            if (index == that.drags.length - 1) {
              arr.active = true;
              arr.draggable = true;
              arr.zIndex = that.drags.length - 1;
            }
            return arr;
          });
          that.activeIndex = that.drags.length - 1;
          that.allIndex = that.drags.length;
          that.selectPhoto = null;
          that.ComIndex = -1;
          that.czHistory = [
            ...that.czHistory,
            { type: "adddrag", index: null, detail: drag },
          ];
          that.originDrags = _.cloneDeep(that.drags);
          that.copyDrag = drag;
          that.savePlateContent();
        }
      }
      if (currKey == 46) {
        if (that.dragsSelectIndexs && that.dragsSelectIndexs.length > 1) {
          that.activeIndex = -1
          var arr = that.dragsSelectIndexs.sort().reverse();
          console.log(arr);
          arr.forEach(async (dragIndex, index) => {
            if (index == arr.length - 1) {
              setTimeout(() => {
                that.dragsSelectIndexs = [];
                arr.forEach((dragIndex) => {
                  that.drags.splice(dragIndex, 1);
                });
              }, 200);
            }
          });
          this.savePlateContent()
          return false;
        }

        var delZindex = that.drags[that.activeIndex].zIndex;
        that.activeIndex--;
        that.drags.splice(that.activeIndex + 1, 1);
        that.savePlateContent();
        if (that.drags.length > 0) {
          that.drags = that.drags.map((arr) => {
            if (arr.zIndex > delZindex) {
              arr.zIndex--;
            }
            return arr;
          });
        }
      }
    };
  },
  computed: {
    ...mapState(["fonts", "netWork", "headers"]),
    leftChatStyle() {
      return {
        cursor: this.leftChatMouseStateMove ? "move" : "auto",
      };
    },
    moveBoxStyle() {
      return {
        top: this.moveBoxTop + "px",
        left: this.moveBoxRight + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.transformX}px ${this.transformY}px`,
      };
    },
    rotateStyle() {
      return {
        top: this.rotateStyles.top - 44 + "px",
        left: this.rotateStyles.left + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.rotateStyles.rotateX}px ${this.rotateStyles
          .rotateY + 44}px`,
      };
    },
    wrapperStyle() {
      return {
        width: this.wrapperWidth + "px",
        height: 750 + "px",
        transform: `scale(${this.sizeSelct / 100}) translate(${
          this.bodyTranslateX
        }px,${this.bodyTranslateY}px)`,
      };
    },
    leftBtnStyle() {
      return {
        right: 400 + "px",
        top: 120 + "px",
      };
    },
  },
  created() {
    this.pageTitle = this.$route.query.name;
    if (this.headers) {
      this.plate_id = this.$route.params.id;
      this.uid = 18;
      this.getcurrentTpl();
      this.getPlateRows();
      this.getFrame();
      this.getFrame2();
      this.getPaster();
      this.getBackground();
      this.getBuiltUp();
      this.getStudent();
    }
  },
  watch: {
    dragsSelectIndexs(newV, oldV) {
      this.drags.forEach((arr) => {
        arr.show = true;
      });
      this.drags = this.drags.map(arr=>{
        arr.selects = false
        return arr
      })
      if (newV.length < 2) return false
      newV.forEach(dragIndex=>{
        this.drags[dragIndex].selects = true
      })
    },
    headers(val) {
      if (val) {
        this.plate_id = this.$route.params.id;
        this.uid = 18;
        this.getcurrentTpl();
        this.getPlateRows();
        this.getFrame();
        this.getFrame2();
        this.getPaster();
        this.getBackground();
        this.getBuiltUp();
        this.getStudent();
      }
    },
    netWork(val) {
      if (val == 0) {
        this.$message.info("网络已断开");
      } else if (val == 1) {
        this.$message.info("当前网络状态较差");
      }
    },
    fonts(val) {
      var sizes = [
        // "262px",
        // "225px",
        "44px",
        "175px",
        "150px",
        "131px",
        "116px",
        "87px",
        "75px",
        "66px",
        "58px",
        "50px",
        "37px",
        // "33px",
        // "28px",
        // "22px",
        // "18px"
      ];
      Quill.Quill.imports["formats/size"].whitelist = sizes;
      Quill.Quill.register(Quill.Quill.imports["formats/size"]);
      const fonts = val;
      Quill.Quill.imports["formats/font"].whitelist = fonts;
      Quill.Quill.register(Quill.Quill.imports["formats/font"]);
      this.editorOption = {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
            // ["blockquote", "code-block"], //引用，代码块
            // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], // 列表
            // [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{ direction: "rtl" }], // 文本方向
            [{ size: sizes }], // 字体大小
            // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: fonts }], // 字体
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除字体样式
            // ["image", "video"], //上传图片、上传视频
          ],
        },
      };
      this.$forceUpdate();
    },
    czHistory(val) {
      if (val.length == 0) return false;
      this.historyChangeState = true;
    },
    step() {
      this.historyChangeState = true;
    },
  },
  beforeDestroy() {
    clearTimeout(this.saveTimeout);
  },
  destroyed() {
    document.onkeydown = undefined;
    document.onkeyup = undefined;
  },
  methods: {
    onChangeMove(e) {
      console.log(e);
    },
    getFrame() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag,
          type: this.frameType,
          limit: 14,
          page: this.currentFrame,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage = res.data.data;
          this.photos = [];
          res.data.data.data.forEach((arr) => {
            this.photos.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getFrame2() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag2,
          type: this.frameType2,
          limit: 18,
          page: this.currentPhoto2,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage2 = res.data.data;
          this.photos2 = [];
          res.data.data.data.forEach((arr) => {
            this.photos2.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    onChangeframePage(e) {
      this.currentFrame = e;
      this.getFrame();
    },
    onChangeframePage2(e) {
      this.currentFrame2 = e;
      this.getFrame2();
    },
    onSearchphotos(e) {
      this.frameTag = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    onSearchphotos2(e) {
      this.frameTag2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    onSearchbacks(e) {
      this.backgroundTag = e;
      this.currentBack = 1;
      this.getBackground();
    },
    onSearchimgs(e) {
      this.pasterTag = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    onSearchbuildup(e) {
      this.buildUpTag = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changePasterType(e) {
      this.pasterType = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    changePasterClassId(e) {
      this.pasterClassId = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    changeBuildType(e) {
      this.buildUpType = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changeFrameType(e) {
      this.frameType = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    changeFrameType2(e) {
      this.frameType2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    changeBackType(e) {
      this.backgroundType = e;
      this.currentBack = 1;
      this.getBackground();
    },
    selectAll() {
      if (this.selectAllState) {
        this.studentList = this.studentList.map((arr) => {
          arr.select = false;
          return arr;
        });
        this.selectAllState = false;
      } else {
        this.studentList = this.studentList.map((arr) => {
          arr.select = true;
          return arr;
        });
        this.selectAllState = true;
      }
    },
    onChangeCheck(index, e) {
      this.$set(this.studentList[index], "select", e.target.checked);
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows.map((arr) => {
            arr.select = false;
            return arr;
          });
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    async handlefenPage() {
      this.moveLoding = true
      const res = await this.$axios({
        method: "POST",
        url: api.main + api.contentMove,
        headers: { Authorization: this.headers },
        data: {
          stc_id:  this.moveId,
          ostc_id: this.pageObject[this.currentRowPage].stc_id,
          is_force: 1,
        },
      });

      if (res.data.status == 200) {
        this.$message.success("迁移成功，请至本学期模版中分配页面给学生");
        this.showfenPage = false;
        this.moveLoding = false
      } else {
        this.$message.success(res.data.msg);
        this.moveLoding = false
      }
    },
    getcurrentTpl() {
      this.$axios({
        method: "POST",
        url: api.main + api.currentTpl,
        headers: { Authorization: this.headers },
      })
        .then((res) => {
          this.load = true;
          if (res.data.status == 200) {
            this.currentTpl = res.data.data;
            axios({
              method: "POST",
              url: api.main + api.getPlateRows,
              headers: { Authorization: this.headers },
              data: {
                st_id: this.currentTpl.st_id,
              },
            })
              .then((res) => {
                if (res.data.status == 200) {
                  this.pageObject2 = res.data.data;
                } else {
                  this.$message.info(res.data.msg);
                }
              })
              .catch((res) => {
                // this.$message('请求错误')
              });
          } else {
            this.$message.error({ content: res.data.msg, key: "load" });
          }
        })
        .catch((res) => {
          this.load = true;
          this.$message.error(res.data.msg);
        });
    },
    handlemovePage() {
      this.showfenPage = true;
    },
    handleRebackPage() {
      this.$confirm({
        title: "提示",
        content: "确认将此页还原为最初的模板吗？",
        centered: true,
        onOk:  () => {
          return new Promise( async (resolve,reject) => {
            const res = await this.$axios({
              method: "POST",
              url: api.main + api.resetPrivateTpl,
              headers: { Authorization: this.headers },
              data: {
                stc_id: this.pageObject[this.currentRowPage].stc_id,
              },
            });

            if (res.data.status == 200) {
              this.$message.success("还原成功");
              this.showSaveTpl = false;
              this.getPlateContent(this.pageObject[this.currentRowPage].stc_id);
              resolve()
            } else {
              this.$message.success(res.data.msg);
              reject()
            }
          })
          
        },
      });
    },
    saveTpl() {
      this.$confirm({
        title: "提示",
        content: "确认将此页保存为个人模板吗？",
        centered: true,
        onOk: () => {
          this.handleSaveToTpl();
        },
      });
    },
    async handleSaveToTpl() {
      if (!this.tplName) {
        this.$message.error("请填写模板名称");
        return;
      }
      this.confirmLoding = true
      const res = await this.$axios({
        method: "POST",
        url: api.main + api.copyNewTpl,
        headers: { Authorization: this.headers },
        data: {
          st_id: this.$route.params.id,
          name: this.tplName,
        },
      });

      if (res.data.status == 200) {
        this.$message.success("复制成功");
        this.showSaveTpl = false;
        this.confirmLoding = false
      } else {
        this.$message.success(res.data.msg);
        this.confirmLoding = false
      }
    },
    handleUnlock(index) {
      this.drags[index].lock = false;
    },
    async addCom2(x, y) {
      var that = this;
      var drag = {
        left: null,
        top: null,
        width: 200,
        height: 28,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 11,
        name: "组合",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        draggable: true,
      };
      drag.left = x;
      drag.top = y;
      drag.orignWidth = this.selectXY.maxX - this.selectXY.minX;
      drag.orignHeight = this.selectXY.maxY - this.selectXY.minY;
      drag.width = this.selectXY.maxX - this.selectXY.minX;
      drag.height = this.selectXY.maxY - this.selectXY.minY;
      let isComs = false;
      this.dragsSelectIndexs.forEach((dragIndex) => {
        let arr = this.drags[dragIndex];
        if (arr.coms) {
          isComs = true;
        }
      });
      if (isComs) {
        this.$message.error("组合不可以重复组合");
        return;
      }
      let lock = false;
      // drag.coms = this.dragsSelectIndexs.map((dragIndex) => {
      //   let arr = { ...this.drags[dragIndex] };
      //   if (this.drags[dragIndex].lock) {
      //     lock = true;
      //   }
      //   arr.left = arr.left - this.selectXY.minX;
      //   arr.top = arr.top - this.selectXY.minY;
      //   this.drags[dragIndex].show = false;
      //   // delete arr.ec_id;
      //   // delete arr.eguc_id;
      //   if (arr.coms) {
      //   }
      //   return arr;
      // });
      // if (lock) {
      //   this.$message.error("锁定的组件无法继续组合");
      //   return false;
      // }
      if (that.keyDown.ctrlKey) {
        drag.zIndex = 0;
      }
      
      this.multipleDrag = _.cloneDeep(drag);
      console.log(this.multipleDrag);
      this.$nextTick(() => {
        this.$refs.multiDrag.activeDrag();
        console.log(this.activeIndex);
        this.$refs.drag[this.activeIndex].cancelActive();
        this.$refs.drag[this.activeIndex].active = false;
        this.$forceUpdate();
      });
    },

    addCom(mode) {
      if (this.dragsSelectIndexs.length < 2) {
        return;
      }
      this.initSelectDom();
      this.addCom2(this.selectXY.minX, this.selectXY.minY);
    },
    cancelBcolor() {
      this.drags[this.activeIndex].bColor = null;
      this.$forceUpdate();
    },
    calcelbordersColor() {
      this.drags[this.activeIndex].bordersColor = null;
      this.$forceUpdate();
    },
    async changeFrame(item) {
      var drag = _.cloneDeep(this.drags[this.activeIndex]);
      var changeIndex = this.activeIndex;
      this.originDrags = _.cloneDeep(this.drags);
      if (drag.type == 1 || drag.type == 9) {
        drag.bLeft = 0;
        drag.bRight = 0;
        drag.bBottom = 0;
        drag.bTop = 0;
        drag.borderRadius = 0;
        drag.bColor = "";
        drag.type = 2;
      }
      drag.backgroundImg = item.backgroundImg;
      drag.backImg2 = item.backImg2;
      drag.height = "auto";
      this.activeIndex = -1;
      this.drags.splice(changeIndex, 1);

      setTimeout(() => {
        this.czHistory = [
          ...this.czHistory,
          {
            type: "change",
            index: changeIndex,
            detail: this.originDrags[changeIndex],
          },
        ];
        this.drags.push(drag);
        this.activeIndex = this.drags.length - 1;
        this.previewFrame = false;
      }, 40);
    },
    handleMouseEnterImg(url) {
      this.priviewImg =
        this.clearUrl(url) +
        "?x-image-process=image/resize,w_480/quality,Q_120";
    },
    handleMouseLeaveImg(url) {
      this.priviewImg = "";
    },
    handleRotateTouchDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateTouchDown(handle, e);
    },
    // 旋转柄按下
    handleRotateDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateDown(handle, e);
    },
    dragRotating(left, top, width, height, rotate, index) {
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    dragResizing(left, top, width, height, rotate, sacle, index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    dragMoving(m, n, index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    fangda() {
      this.$refs.drag[this.activeIndex].fangda();
    },
    suoxiao() {
      this.$refs.drag[this.activeIndex].suoxiao();
    },
    handleRotateUp() {
      this.$refs.drag[this.activeIndex].handleRotateUp();
    },
    handleMoveTouchDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleMoveTouchDown(handle, e);
    },
    // 旋转柄按下
    handleMoveDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleMoveDown(handle, e);
    },
    changeLevelType(e) {
      this.drags[this.activeIndex].levelType = e;
    },
    changeLevel(n, index) {
      this.drags[index].level = n;
      this.$forceUpdate();
      this.changeDragHistory(index);
      this.savePlateContent();
    },
    async copythisDrag() {
      var that = this;
      that.copyDrag = _.cloneDeep(this.drags[this.activeIndex]);
      delete that.copyDrag.estc_id;
      delete that.copyDrag.stc_id;
      delete that.copyDrag.st_id;
      var drag = that.copyDrag;
      drag.key = this.random + 1;
      // drag.left += 10
      // drag.top += 10
      this.random += 1;
      that.drags = [...that.drags, drag];
      that.drags.forEach((arr, index) => {
        arr.active = false;
        arr.draggable = false;
        arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
        if (index == that.drags.length - 1) {
          arr.active = true;
          arr.draggable = true;
          arr.zIndex = that.drags.length - 1;
        }
        return arr;
      });
      that.activeIndex = that.drags.length - 1;
      that.allIndex = that.drags.length;
      that.selectPhoto = null;
      that.ComIndex = -1;
      that.czHistory = [
        ...that.czHistory,
        { type: "adddrag", index: null, detail: drag },
      ];
      that.originDrags = _.cloneDeep(that.drags);
      that.copyDrag = drag;
    },
    changeLevelData(type, num, level, size, index, height) {
      this.drags[index].fSize = size;
      this.$set(this.drags[index], "height", height);
      this.$forceUpdate();
      this.$nextTick(() => {
        this.savePlateContent();
      });
    },
    changePasterClass() {
      this.getPaster();
    },
    onSearchBuild() {
      this.getBuiltUp();
    },
    onSearchBack() {
      this.getBackground();
    },
    onSearchPaster() {
      this.getPaster();
    },
    onSearchPhoto() {
      this.getFrame();
    },
    onSearchPhoto2() {
      this.getFrame2();
    },
    handleRemoveDrag() {
      var that = this;
      var delZindex = that.drags[that.activeIndex].zIndex;
      if (that.activeIndex > 0) {
        that.activeIndex--;
        that.drags.splice(that.activeIndex + 1, 1);
      } else {
        that.drags.splice(that.activeIndex, 1);
      }
      if (that.drags.length > 0) {
        that.drags.map((arr) => {
          if (arr.zIndex > delZindex) {
            arr.zIndex--;
          }
          return arr;
        });
      } else {
        that.activeIndex = 0;
      }
      that.savePlateContent();
    },
    handleCancelEdit() {
      this.eiditVisible = false;
    },
    getMaxFont(txt) {
      var regeQl = /ql-size-([\d]+)|font-size:[\s]*([\d]+)px/;
      var result = [];
      var maxFsize = 0;
      var matched = txt.match(regeQl);
      while (matched != null) {
        if (matched[1] != null) {
          result.push(matched[1]);
          if (matched[1] > maxFsize) {
            maxFsize = matched[1];
          }
        }
        if (matched[2] != null) {
          result.push(matched[2]);
          if (matched[2] > maxFsize) {
            maxFsize = matched[2];
          }
        }
        txt = txt.substr(matched.index + matched[0].length);
        matched = txt.match(regeQl);
      }
      switch (maxFsize) {
        case "175":
          maxFsize = 58.667;
          break;
        case "150":
          maxFsize = 48;
          break;
        case "116":
          maxFsize = 34.667;
          break;
        case "44":
          maxFsize = 14;
          break;
        case "131":
          maxFsize = 32;
          break;

        case "87":
          maxFsize = 29.333;
          break;

        case "66":
          maxFsize = 21.333;
          break;

        case "75":
          maxFsize = 24;
          break;

        case "58":
          maxFsize = 18.667;
          break;

        case "50":
          maxFsize = 16;
          break;

        case "37":
          maxFsize = 12;
          break;
      }
      return maxFsize;
    },
    onChangeAutoSize(e) {
      this.drags[this.activeIndex].lineHeightAutoSize = e.target.checked
        ? 1
        : 0;
      this.savePlateContent();
    },
    async confirmEdit() {
      var maxFsize = this.getMaxFont(this.editText);
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        if (maxFsize) {
          this.drags[this.activeIndex].lineHeight = Math.ceil(maxFsize * 1.23);
        } else {
          this.drags[this.activeIndex].lineHeight = 18;
        }
      }
      this.drags[this.activeIndex].textarea = this.editText;
      this.eiditVisible = false;
      this.savePlateContent();
    },
    showEdit(index) {
      this.editText = this.drags[index].textarea;
      this.eiditVisible = true;
      setTimeout(() => {
        addQuillTitle();
      }, 40);
    },
    onEditorBlur() {},
    onEditorFocus() {},
    onEditorChange(e) {
      // this.editText = e.html;
    },
    changeSwitch(e) {
      this.drags[this.activeIndex].shadow = e;
      this.$forceUpdate();
    },
    onPlateSearch() {
      this.currentPage = 1;
      this.getPlateList();
    },
    changeAddtype(e) {
      if (this.addType) {
        this.currentPage = 1;
        this.getPlateList();
      }
    },
    onChangePlatePage(e) {
      this.currentPage = e;
      this.getPlateList();
    },
    getPlateList() {
      axios({
        method: "POST",
        url: api.main + api.searchPlate,
        headers: { Authorization: this.headers },
        data: {
          uid: this.uid,
          t_id: this.plate_id,
          type: this.addType,
          page: this.currentPage,
          limit: 10,
          name: this.plate_name,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.plateList = res.data.data.data;
            this.plateTotal = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    urladd(name) {
      let url = window.location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
    cancelStep() {
      if (this.dq_step) {
        this.dragsSelectIndexs.forEach((dragIndex, index) => {
          this.drags[dragIndex] = this.dragsSelect[index];
        });
        this.$forceUpdate();
        return;
      }
      if (this.step == -1) return false;
      this.changeStepState = true;
      if (this.czHistory[this.step].type == "change") {
        var drag = _.cloneDeep(this.drags[this.czHistory[this.step].index]);
        this.drags[this.czHistory[this.step].index] = this.czHistory[
          this.step
        ].detail;
        this.czHistory[this.step].detail = drag;
      }
      if (this.czHistory[this.step].type == "changeBack") {
        var back = this.backgroundImage;
        this.backgroundImage = this.czHistory[this.step].detail;
        this.czHistory[this.step].detail = back;
      }
      if (this.czHistory[this.step].type == "delete") {
        this.drags.splice(this.czHistory[this.step].index, 0, detail);
      }
      if (this.czHistory[this.step].type == "adddrag") {
        var drag = _.cloneDeep(this.drags[this.czHistory[this.step].index]);
        this.drags.splice(this.drags.length - 1, 1);
        this.czHistory[this.step].detail = drag;
      }
      if (this.czHistory[this.step].type == "confirmCom") {
        this.drags.splice(
          this.drags.length - 1 - this.czHistory[this.step].detail.coms.length,
          this.czHistory[this.step].detail.coms.length
        );
        this.drags = [...this.drags, this.czHistory[this.step].detail];
      }

      this.originDrags = _.cloneDeep(this.drags);
      this.step--;
      this.$forceUpdate();
    },
    nextStep() {
      if (this.step < this.czHistory.length - 1) {
        this.changeStepState = true;
        this.step++;
        if (this.czHistory[this.step].type == "change") {
          var drag = _.cloneDeep(this.drags[this.czHistory[this.step].index]);
          this.drags[this.czHistory[this.step].index] = this.czHistory[
            this.step
          ].detail;

          this.czHistory[this.step].detail = drag;
        }
        if (this.czHistory[this.step].type == "changeBack") {
          var back = this.backgroundImage;
          this.backgroundImage = this.czHistory[this.step].detail;
          this.czHistory[this.step].detail = back;
        }
        if (this.czHistory[this.step].type == "delete") {
          this.drags.splice(this.czHistory[this.step].index, 1);
        }
        if (this.czHistory[this.step].type == "adddrag") {
          this.drags = [...this.drags, this.czHistory[this.step].detail];
        }
        if (this.czHistory[this.step].type == "confirmCom") {
          this.drags.splice(this.drags.length - 1, 1);
          var indexL = this.drags.length;
          this.czHistory[this.step].detail.coms.forEach((arr, index3) => {
            arr.zIndex = indexL + index3;
            arr.left = this.drags[index].left + arr.left;
            arr.top = this.drags[index].top + arr.top;
            this.drags = [...this.drags, arr];
          });
        }
        this.originDrags = _.cloneDeep(this.drags);
        this.$forceUpdate();
      }
    },
    saveHistoryChange() {
      if (this.historyChangeState) {
        this.savePlateContent();
      }
      this.saveTimeout = setTimeout(() => {
        this.saveHistoryChange();
      }, 4500);
    },
    listenMouseDown(e) {
      if (this.leftChatMouseStateMove) {
        this.leftChatPointX = e.layerX;
        this.leftChatPointY = e.layerY;
        this.originbodyTranslateX = this.bodyTranslateX;
        this.originbodyTranslateY = this.bodyTranslateY;
        this.$refs["leftChat"].addEventListener(
          "mousemove",
          this.listenMouseMove
        );
      }
    },
    listenMouseMove(e) {
      if (!this.leftChatMouseStateMove || this.mouseEnterBody) {
        this.$refs["leftChat"].removeEventListener(
          "mousemove",
          this.listenMouseMove
        );
        return false;
      }
      var transformX = this.leftChatPointX - e.layerX;
      var transformY = this.leftChatPointY - e.layerY;
      this.bodyTranslateX = this.originbodyTranslateX - transformX;
      this.bodyTranslateY = this.originbodyTranslateY - transformY;
    },
    changeDragHistory(index) {
      if (this.step < this.czHistory.length - 1) {
        this.czHistory.splice(
          this.step + 1,
          this.czHistory.length - this.step - 1
        );
      }
      this.czHistory = [
        ...this.czHistory,
        { type: "change", index: index, detail: this.originDrags[index] },
      ];
      this.originDrags = _.cloneDeep(this.drags);
      this.step = this.czHistory.length - 1;
      return false;
      if (this.step < this.czHistory.length - 1) {
        this.changeStepState = false;
      } else {
        if (this.step < this.czHistory.length - 1) {
          this.czHistory.splice(
            this.step + 1,
            this.czHistory.length - this.step - 1
          );
        }
        this.czHistory = [
          ...this.czHistory,
          { type: "change", index: index, detail: this.originDrags[index] },
        ];
        this.originDrags = _.cloneDeep(this.drags);
        this.step = this.czHistory.length - 1;
      }
    },
    confirmPageType() {
      if (!this.addType) {
        axios({
          method: "POST",
          url: api.main + api.addPlateContent,
          headers: { Authorization: this.headers },
          data: {
            uid: this.uid,
            t_id: this.plate_id,
            type: this.selectPageType,
            page_num:
              this.currentRowPage == -1 || this.selectPageType != 2
                ? 0
                : this.pageObject[this.currentRowPage].page_num + 1,
            thumb: this.pageInfo.thumb,
          },
        })
          .then((res) => {
            if (res.data.status == 200) {
              this.$message.success(res.data.msg);
              this.getPlate(true);
              this.showTypeSelect = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((res) => {
            // this.$message('请求错误')
          });
      } else {
        var plate = null;
        this.plateList.forEach((arr) => {
          if (arr.select) {
            plate = arr;
          }
        });
        if (!plate) {
          this.$message.error("请先选择复制的模板");
        } else {
          console.log(plate);
          axios({
            method: "POST",
            url: api.main + api.copyPlate,
            headers: { Authorization: this.headers },
            data: {
              uid: this.uid,
              st_id: plate.t_id,
              tt_id: this.plate_id,
            },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg);
                this.getPlateRows();
                this.showTypeSelect = false;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((res) => {
              // this.$message('请求错误')
            });
        }
      }
    },
    handleCustomMatcher(node, delta) {
      const opsList = [];
      delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          opsList.push({
            insert: op.insert,
          });
        }
      });
      delta.ops = opsList;
      console.log(delta);
      return delta;
    },
    changePage(e) {
      this.selectPageType = e;
      console.log(e);
    },
    addPage() {
      console.log(this.typeSelector, this.typeSelect);
      if (this.typeSelector.length == 0 || !this.typeSelector) {
        this.$message.error("当前状态不可添加新页面");
        return false;
      }
      this.showTypeSelect = true;
    },

    getPlate(state) {
      axios({
        method: "POST",
        url: api.main + api.getPlateSizeDetail,
        headers: { Authorization: this.headers },
        data: {
          st_id: this.plate_id,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.data) {
            var cover_size = res.data.data.cover_size.split("*");
            this.cover_size = cover_size;
            this.getBackground();
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            setTimeout(() => {
              var dom = this.$refs["body"].getBoundingClientRect();
              this.fixBtnLeft = dom.right + 20;
            }, 600);
            this.getPlateRows(true);
          } else {
            this.checkaddPages();
          }
        })
        .catch((res) => {
          this.$message.error("请求错误");
        });
    },
    changeHeight(height, index) {
      this.drags[index].height = height;
    },
    checkaddPages() {
      if (!this.plate_type) {
        this.typeSelector = [
          { type: 1, name: "封面" },
          { type: 3, name: "封底" },
        ];
        this.typeSelect = "";
        this.selectPageType = "";
        return false;
      }
      switch (this.plate_type) {
        case 1:
          var pagenums = [];
          var fm, fd;
          this.pageObject.forEach((arr) => {
            if (arr.page_num) {
              pagenums.push(arr.page_num);
            }
            if (arr.type == 1 || arr.type == 9) {
              fm = true;
            }
            if (arr.type == 3) {
              fd = true;
            }
          });
          this.maxPage = _.max(pagenums) ? _.max(pagenums) : 0;
          if (fm && fd) {
            this.typeSelector = [{ type: 2, name: "内页" }];
          } else if (!fm && fd) {
            this.typeSelector = [{ type: 1, name: "封面" }];
          } else if (fm && !fd) {
            this.typeSelector = [{ type: 3, name: "封底" }];
          } else if (!fm && !fd) {
            this.typeSelector = [
              { type: 1, name: "封面" },
              { type: 3, name: "封底" },
            ];
          }
          this.typeSelect = this.typeSelector[0].type;
          this.selectPageType = this.typeSelector[0].type;
          break;

        case 2:
          this.typeSelector = [{ type: 2, name: "内页" }];
          this.typeSelect = this.typeSelector[0].type;
          this.selectPageType = this.typeSelector[0].type;
          break;
        case 3:
          var pagenums = [];
          var fm, fd;
          this.pageObject.forEach((arr) => {
            if (arr.page_num) {
              pagenums.push(arr.page_num);
            }
            if (arr.type == 1 || arr.type == 9) {
              fm = true;
            }
            if (arr.type == 3) {
              fd = true;
            }
          });
          this.maxPage = _.max(pagenums) ? _.max(pagenums) : 0;
          if (fm && fd) {
            this.typeSelector = [];
            this.typeSelect = "";
            this.selectPageType = "";
          } else if (!fm && fd) {
            this.typeSelector = [{ type: 1, name: "封面" }];
            this.typeSelect = this.typeSelector[0].type;
            this.selectPageType = this.typeSelector[0].type;
          } else if (fm && !fd) {
            this.typeSelector = [{ type: 3, name: "封底" }];
            this.typeSelect = this.typeSelector[0].type;
            this.selectPageType = this.typeSelector[0].type;
          } else if (!fm && !fd) {
            this.typeSelector = [
              { type: 1, name: "封面" },
              { type: 3, name: "封底" },
            ];
            this.typeSelect = this.typeSelector[0].type;
            this.selectPageType = this.typeSelector[0].type;
          }
          this.$forceUpdate();
          break;
        default:
          break;
      }
    },
    getPlateRows(state) {
      axios({
        method: "POST",
        url: api.main + api.getPlateRows,
        headers: { Authorization: this.headers },
        data: {
          uid: this.uid,
          st_id: this.plate_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.pageObject = res.data.data;
            this.currentRowPage = this.$route.query.page;
            this.getPlateContent(this.pageObject[this.currentRowPage].stc_id);
          } else {
            this.$message.info(res.data.msg);
          }
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    calcPos(index) {
      console.log(index);
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;
      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    confirmComb(index, zIndex) {
      var indexL = this.drags.length;
      this.drags[index].coms.forEach((arr, index3) => {
        arr.zIndex = indexL + index3;
        const scaleX = this.drags[index].orignWidth
          ? this.drags[index].width / this.drags[index].orignWidth
          : 1;
        const scaleY = this.drags[index].orignHeight
          ? this.drags[index].height / this.drags[index].orignHeight
          : 1;
        arr.left = arr.left * scaleX + this.drags[index].left;
        arr.top = arr.top * scaleY + this.drags[index].top;
        arr.width = arr.width * scaleX;
        arr.height = arr.height * scaleY;
        arr.c_id ? delete arr.c_id : () => {};
        arr.bu_id ? delete arr.bu_id : () => {};
        arr.ebu_id ? delete arr.ebu_id : () => {};
        arr.create_time ? delete arr.create_time : () => {};
        arr.update_time ? delete arr.update_time : () => {};
        arr.key = this.random + 1;
        this.random += 1;
        this.drags = [...this.drags, arr];
      });
      if (this.step < this.czHistory.length - 1) {
        this.czHistory.splice(
          this.step + 1,
          this.czHistory.length - this.step - 1
        );
      } else {
        this.czHistory = [
          ...this.czHistory,
          { type: "confirmCom", index: index, detail: this.drags[index] },
        ];
      }

      this.drags.splice(index, 1);
      this.drags[this.activeIndex].draggable = true;
      this.originDrags = _.cloneDeep(this.drags);
      this.allIndex = this.drags.length;
    },
    handleSelectSquire() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 200,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#fff",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 7,
        name: "矢量框",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    handleSelectCircle() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 200,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "#fff",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#999",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 200,
        type: 7,
        name: "矢量圆",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    handleSelectLine() {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 200,
        height: 2,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        bordersColor: "#333333",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 2,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        lineHeightAutoSize: 1,
        borderRadius: 0,
        type: 8,
        name: "矢量线",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
    },
    addDrag(e) {
      console.log("adddrag" + JSON.stringify(e));
      var drag;
      if (this.ComIndex >= 0) {
        drag = _.cloneDeep(this.buildUp[this.ComIndex]);
        drag.left = e.layerX - drag.width / 2;
        drag.top = e.layerY - drag.height / 2;
        drag.orignWidth = drag.width;
        drag.orignHeight = drag.height;
        console.log(drag);
      } else if (this.selectPhoto) {
        this.selectPhoto.left = e.layerX - this.selectPhoto.width / 2;
        this.selectPhoto.top = e.layerY;
        drag = {
          allIndex: this.drags.length + 1,
          left: e.layerX - this.selectPhoto.width / 2,
          top:
            e.layerY -
            (this.selectPhoto.height != "auto"
              ? this.selectPhoto.height
              : this.selectHeight) /
              2,
          width: this.selectPhoto.width,
          height: this.selectPhoto.height ? this.selectPhoto.height : "auto",
          rotate: this.selectPhoto.rotate,
          lockAspectRatio: this.selectPhoto.lockAspectRatio,
          textarea: this.selectPhoto.textarea,
          minW: this.selectPhoto.minW,
          minH: this.selectPhoto.minH,
          type: this.selectPhoto.type,
          lineHeightAutoSize: 1,
          backgroundImg: this.clearUrl(this.selectPhoto.backgroundImg),
          backImg2: this.clearUrl(this.selectPhoto.backImg2),
          maxW: this.selectPhoto.maxW,
          maxH: this.selectPhoto.maxH,
          lock: !!this.selectPhoto.lock,
          zIndex: this.drags.length,
          bColor: this.selectPhoto.bColor,
          fSize: this.selectPhoto.fSize,
          fColor: this.selectPhoto.fColor,
          bordersColor: this.selectPhoto.bordersColor,
          bLeft: this.selectPhoto.bLeft,
          bTop: this.selectPhoto.bTop,
          bRight: this.selectPhoto.bRight,
          bBottom: this.selectPhoto.bBottom,
          bStyle: this.selectPhoto.bStyle,
          paddingLeft: this.selectPhoto.paddingLeft,
          paddingTop: this.selectPhoto.paddingTop,
          paddingRight: this.selectPhoto.paddingRight,
          paddingBottom: this.selectPhoto.paddingBottom,
          borderRadius: this.selectPhoto.borderRadius,
          opacity: this.selectPhoto.opacity,
          showPhoto: this.clearUrl(this.selectPhoto.showPhoto),
          lineHeight: this.selectPhoto.lineHeight,
          key: this.random + 1,
          fontWeight: this.selectPhoto.fontWeight,
          fontStyle: this.selectPhoto.fontStyle,
          textAlign: this.selectPhoto.textAlign,
          combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
        };
        console.log(drag);
      }
      this.drags = [...this.drags, drag];
      this.random += 1;
      this.drags.forEach((arr, index) => {
        arr.active = false;
        arr.draggable = false;
        if (index == this.drags.length - 1) {
          arr.active = true;
          arr.zIndex = this.drags.length - 1;
          arr.draggable = true;
        }
        return arr;
      });
      this.activeIndex = this.drags.length - 1;
      this.allIndex = this.drags.length;
      this.selectPhoto = null;
      this.ComIndex = -1;
      // this.calcPos(this.activeIndex)
      this.czHistory = [
        ...this.czHistory,
        { type: "adddrag", index: null, detail: drag },
      ];
      this.originDrags = _.cloneDeep(this.drags);
    },
    save() {
      if (this.drags.length == 0) {
        this.$message.error("请先添加组件");
        return false;
      }
      axios({
        method: "POST",
        url: api.main + api.getBuiltUp,
        headers: { Authorization: this.headers },
        data: {
          uid: this.uid,
          thumb: "",
          content: this.drags,
        },
      })
        .then((res) => {
          this.$message.success("保存组合成功");
          if (res.data.status == 200) {
            this.drags = [];
          }
        })
        .catch(() => {});
    },
    changeBuildId(e) {
      this.buildId = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changePasterId(e) {
      this.pasterId = e;
      this.currentImg = 1;
      this.getPaster();
    },
    changeBackId(e) {
      this.backId = e;
      this.currentBack = 1;
      this.getBackground();
    },
    changePhotoId(e) {
      this.photoId = e;
      this.currentPhoto = 1;
      this.getFrame();
    },
    changePhotoId2(e) {
      this.photoId2 = e;
      this.currentPhoto2 = 1;
      this.getFrame2();
    },
    getBuiltUp() {
      axios({
        method: "GET",
        url: api.domain + api.getBuiltUp2,
        headers: { Authorization: this.$store.state.headers },
        params: {
          tags: this.buildUpTag,
          type: this.buildUpType,
          limit: 15,
          page: this.currentBuild,
        },
      })
        .then((res) => {
          this.buildUpPage = res.data.data;
          this.buildUp = [];
          res.data.data.data.forEach((arr, index) => {
            var coms = arr.content;
            let data;
            coms.forEach((com, index) => {
              if (index == 0) {
                data = arr.content[0];
                var maxL = data.width > data.height ? data.width : data.height;
                data.scale = 99 / maxL;
                data.type = 3;
                data.coms = [];
              } else {
                data.coms.push(com);
              }
            });
            this.buildUp.push(data);
          });
          console.log(this.buildUp);
        })
        .catch((res) => {});
    },

    catchClick() {
      var that = this;
      setTimeout(() => {
        if (that.activeIndex >= 0 && this.dragsSelectIndexs && this.dragsSelectIndexs.length < 2) {
          that.dragsSelectIndexs = [];
          that.dragsSelectList = [];
          if (that.$refs["drag"][that.activeIndex]) {
            that.$refs["drag"][that.activeIndex].activeDrag();
            that.dragsSelect = [{ ...that.drags[that.activeIndex] }];
            console.log(this.dragsSelect);
            that.dragsSelectIndexs = [that.activeIndex];
            that.dragsSelect[0].index = that.activeIndex;
            that.$set(that.drags[that.activeIndex], "shiftkey", true);
            that.showIcon = true;
          } 
        } else {
          if (this.multipleDrag && this.dragsSelectIndexs.length > 1) {
            that.$refs.multiDrag.activeDrag();
          }
          
        }
      }, 100);
    },
    resizingComStop(left, top, width, height, picLeft, picTop, index, raduis,scaleP) {
      console.log("dragging:" ,height);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      this.multipleDrag.left = left;
      this.multipleDrag.top = top;
      this.multipleDrag.width = width;
      this.multipleDrag.height = height;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        let left = this.multipleDrag.left + (this.drags[dragIndex].left  - this.multipleDrag.left ) * scaleP + parseInt(movLeft);
        let top = this.multipleDrag.top + (this.drags[dragIndex].top - this.multipleDrag.top)* scaleP + parseInt(movTop);
        const width = this.drags[dragIndex].width * scaleP
        const height =  this.drags[dragIndex].height == 'auto' ? 'auto' :  this.drags[dragIndex].height * scaleP
        const fSize = this.drags[dragIndex].fSize ? Number((this.drags[dragIndex].fontSize * scaleP).toFixed(2)): 12
        let borderRadius;
        if (this.drags[dragIndex].type == 9) {
          borderRadius = this.drags[dragIndex].borderRadius * scaleP
        }
        this.drags[dragIndex].left = left;
        this.drags[dragIndex].top = top;
        this.drags[dragIndex].width = width;
        this.drags[dragIndex].height = height;
        this.drags[dragIndex].borderRadius = borderRadius
        this.$forceUpdate();
        this.changeDragHistory(dragIndex);
      });
      
    },
    resizingCom(left, top, width, height, picLeft, picTop, index,scaleP) {
      console.log("dragging:" ,height);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      // const scaleP = width / this.multipleDrag.width
      // this.multipleDrag.left = left;
      // this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        let left = this.multipleDrag.left + (this.drags[dragIndex].left  - this.multipleDrag.left ) * scaleP + parseInt(movLeft);
        let top = this.multipleDrag.top + (this.drags[dragIndex].top - this.multipleDrag.top)* scaleP + parseInt(movTop);
        const width = this.drags[dragIndex].width * scaleP
        const height =  this.drags[dragIndex].height == 'auto' ? 'auto' :  this.drags[dragIndex].height * scaleP
        const fSize = this.drags[dragIndex].fSize ? Number((this.drags[dragIndex].fontSize * scaleP).toFixed(2)): 12
        let borderRadius;
        if (this.drags[dragIndex].type == 9) {
          borderRadius = this.drags[dragIndex].borderRadius * scaleP
        }
        this.$refs.drag[dragIndex].setData({ left: left, top: top ,width,height,fSize,borderRadius});
      });
      this.$forceUpdate();
    },
    draggingCom(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      // this.multipleDrag.left = left;
      // this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        const left = this.drags[dragIndex].left + parseInt(movLeft);
        const top = this.drags[dragIndex].top + parseInt(movTop);

        this.$refs.drag[dragIndex].setData({ left: left, top: top });
        this.$forceUpdate();
      });
    },
    draggingComStop(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      if (isNaN(left) || isNaN(top)) return false;
      const movLeft = left - this.multipleDrag.left;
      const movTop = top - this.multipleDrag.top;
      this.multipleDrag.left = left;
      this.multipleDrag.top = top;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        this.drags[dragIndex].left =
          this.drags[dragIndex].left + parseInt(movLeft);
        this.drags[dragIndex].top =
          this.drags[dragIndex].top + parseInt(movTop);
        this.$forceUpdate();
        this.$refs.drag[dragIndex].update()
        this.changeDragHistory(dragIndex);
      });
    },
    getPaster() {
      if (this.pasterType == 3) {
        axios({
          method: "GET",
          url: this.$api.domain + this.$api.personalPhoto,
          headers: { Authorization: this.$store.state.headers },
          params: {
            limit: 16,
            page: this.currentPaster,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.imgs = res.data.data.list;
              this.imgPage = {
                total: res.data.data.count,
                current_page: this.currentPaster,
              };
              console.log(this.imgPage);
            }
          })
          .catch((res) => {
            console.log(res);
            console.log("getpaster错误");
            this.$message.error("服务器或网络错误");
          });
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.getPaster2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.pasterTag,
          type: this.pasterType,
          paster_class: this.pasterClassId,
          limit: 16,
          page: this.currentPaster,
        },
      })
        .then((res) => {
          this.imgPage = res.data.data;
          this.imgs = [];
          for (var index in res.data.data.data) {
            res.data.data.data[index].paster +=
              "?x-image-process=image/resize,w_100/quality,Q_80";
            this.imgs.push(res.data.data.data[index]);
          }
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    getBackground() {
      axios({
        method: "POST",
        url: api.domain + api.getBackground2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.backgroundTag,
          size: this.cover_size.join("*"),
          limit: 12,
          type: this.backgroundType,
          page: this.currentBack,
        },
      })
        .then((res) => {
          this.backPage = res.data.data;
          this.backs = res.data.data.data.map((arr) => {
            arr.background +=
              "?x-image-process=image/resize,w_100/quality,Q_80";
            return arr;
          });
        })
        .catch((res) => {});
    },
    onChangeImgPage(e) {
      this.currentPaster = e;
      this.getPaster();
    },
    onChangeBuildPage(e) {
      this.currentBuild = e;
      this.getBuiltUp();
    },
    onChangePhotoPage(e) {
      this.currentPhoto = e;
      this.getFrame();
    },
    onChangePhotoPage2(e) {
      this.currentPhoto2 = e;
      this.getFrame2();
    },
    changePageNum(index) {
      if (this.saveDraging) {
        this.$message.info("正在保存此页，请稍后");
        return false;
      }
      this.dragsSelectIndexs = []
      this.dragsSelect = []
      this.multipleDrag = null
      this.currentRowPage = index;
      this.$router.replace({
        path: "/tplPagesPrivate/" + this.$route.params.id,
        query: {
          page: index,
          name: this.$route.query.name
        },
      });
      this.czHistory = [];
      this.historyChangeState = false;
      this.activeIndex = -1;
      this.drags = [];
      clearTimeout(this.savetimeout);

      this.getPlateContent(this.pageObject[index].stc_id);
    },
    matchSpace(text) {
      var rel = />[\s]+/g;
      var match = text.match(rel);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/[\s]/g, "&nbsp;");
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log("空格处理");
      console.log(text);
      console.log(match);
      console.log(content);
      content = this.matchSpace2(content);
      return content;
    },
    matchSpace2(text, rel) {
      var rel = /&nbsp;[\s]+/g;
      var match = text.match(rel);
      console.log("空格二次处理");
      console.log(text);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/[\s]/g, "&nbsp;");
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log(content);
      return content;
    },
    savePlateContent() {
      this.saveDraging = true;
      this.historyChangeState = false;
      var drags = _.cloneDeep(this.drags);
      var originDrags = [...this.drags];
      var backgrounimg = this.backgroundImage;
      console.log(this.backgroundImage);
      drags = drags.map((arr) => {
        // if (arr.textarea) {
        //   arr.textarea = encodeURI(arr.textarea);
        // }
        if (arr.textarea) arr.textarea = arr.textarea.replace(/<br\/>/g, "\n");
        arr.backgroundImg = this.clearUrl(arr.backgroundImg);
        arr.showPhoto = this.clearUrl(arr.showPhoto);
        arr.backImg2 = this.clearUrl(arr.backImg2);
        delete arr.allIndex;
        delete arr.active;
        return arr;
      });
      axios({
        method: "POST",
        url: api.main + api.editAllPage,
        headers: { Authorization: this.headers },
        data: {
          stc_id: this.pageObject[this.currentRowPage].stc_id,
          type: this.pageObject[this.currentRowPage].type,
          // page_num: this.pageObject[this.currentRowPage].page_num,
          thumb: this.pageInfo.thumb,
          img_bg: this.backgroundImage,
          content: JSON.stringify(drags),
        },
      }).then((res) => {
        this.$message.success({
          content: "保存成功",
          key: "upload",
          duration: 2,
        });
        this.saveDraging = false;
      });
    },
    savePlateContent2() {
      this.activeIndex = -1;
      this.showCanvasImg = true;
      this.saveDraging = true;
      this.historyChangeState = false;
      var drags = _.cloneDeep(this.drags);
      var originDrags = [...this.drags];
      var backgrounimg = this.backgroundImage;
      console.log(this.backgroundImage);
      this.$message.loading({ content: "正在生成缩略图", key: "upload" });
      drags = drags.map((arr) => {
        // if (arr.textarea) {
        //   arr.textarea = encodeURI(arr.textarea);
        // }
        arr.backgroundImg = this.clearUrl(arr.backgroundImg);
        arr .showPhoto = this.clearUrl(arr.showPhoto);
        arr.backImg2 = this.clearUrl(arr.backImg2);
        delete arr.allIndex;
        delete arr.active;
        return arr;
      });
      setTimeout(() => {
        html2canvas(this.$refs.body, {
          backgroundColor: null,
          useCORS: true,
        })
          .then((canvas) => {
            var blob = getBlob(canvas);
            var fd = new FormData();
            fd.append("file", blob, "image.png");
            let url = canvas.toDataURL("image/png");
            this.htmlUrl = url;
            console.log(this.pageObject, this.currentRowPage);
            axios({
              method: "POST",
              url: api.main + api.albumAdd,
              headers: { Authorization: this.headers },
              data: fd,
            })
              .then((res) => {
                this.showCanvasImg = false;
                if (res.data.status == 200) {
                  axios({
                    method: "POST",
                    url: api.main + api.editAllPage,
                    headers: { Authorization: this.headers },
                    data: {
                      stc_id: this.pageObject[this.currentRowPage].stc_id,
                      type: this.pageObject[this.currentRowPage].type,
                      // page_num: this.pageObject[this.currentRowPage].page_num,
                      thumb: res.data.data.url,
                      img_bg: this.backgroundImage,
                      content: JSON.stringify(drags),
                    },
                  }).then((res) => {
                    this.pageInfo.thumb = res.data.data.url
                    this.$message.success({
                      content: "保存成功",
                      key: "upload",
                      duration: 2,
                    });
                    this.saveDraging = false;
                  });
                }
              })
              .catch((e) => {
                console.log(e);
                this.showCanvasImg = false;
                this.$message.error({
                  content: "保存失败",
                  key: "upload",
                  duration: 2,
                });
              });
          })
          .catch((res) => {
            this.showCanvasImg = false;
            console.log(res);
          });
      }, 400);
    },
    handleCustomMatcher(node, delta) {
      const opsList = [];
      delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          opsList.push({
            insert: op.insert,
          });
        }
      });
      delta.ops = opsList;
      console.log(delta);
      return delta;
    },
    delPlateContent() {
      this.$confirm({
        title: "确认删除？",
        content: "删除后数据不可恢复",
        centered: true,
        onOk: () => {
          axios({
            method: "POST",
            url: api.main + api.delPlateContent,
            headers: { Authorization: this.headers },
            data: {
              uid: this.uid,
              tc_id: this.pageObject[this.currentRowPage].tc_id,
            },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg);
                this.currentRowPage--;
                this.getPlateRows();
                this.backgroundImage = "";
                this.drags = [];
                this.historyChangeState = false;
              }
            })
            .catch((res) => {
              this.$message.error("操作失败");
              // this.$message('请求错误')
            });
        },
        onCancel() {},
      });
    },
    getPlateContent(id) {
      this.activeIndex = -1;
      axios({
        method: "POST",
        url: api.main + api.getPlatePageDetail,
        headers: { Authorization: this.headers },
        data: {
          stc_id: id,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            const data = res.data.data.info;
            this.pageInfo = data
            var cover_size = data.cover_size.split("*");
            this.cover_size = cover_size;
            this.getBackground();
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            setTimeout(() => {
              var dom = this.$refs["body"].getBoundingClientRect();
              this.fixBtnLeft = dom.right + 20;
            }, 600);
            if (!data.content || data.content.length == 0) {
              this.drags = [];
              this.savetimeout = setTimeout(() => {
                this.saveHistoryChange();
              }, 4500);
            } else {
              this.savetimeout = setTimeout(() => {
                this.saveHistoryChange();
              }, 4500);
              this.drags = data.content.map((arr) => {
                arr.active = false;
                arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
                arr.draggable = false;
                arr.key = this.random + 1;
                arr.lock = !!arr.lock;
                arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                  ? this.clearUrl(arr.backgroundImg) +
                    "?x-image-process=image/resize,w_750/quality,Q_120"
                  : "";
                arr.showPhoto = this.clearUrl(arr.showPhoto)
                  ? this.clearUrl(arr.showPhoto) +
                    "?x-image-process=image/resize,w_750/quality,Q_120"
                  : "";
                this.random += 1;
                if (arr.fontStyle == "normal") {
                  arr.fontStyle = "horizontal-tb";
                }
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                }
                return arr;
              });
              this.originDrags = _.cloneDeep(this.drags);
            }
            this.backgroundImage = data.img_bg;
          }
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    onChangeBackPage(e) {
      this.currentBack = e;
      this.getBackground();
    },
    changeContent(content, height, oldContent, index) {
      console.log(this.drags[index], index);
      oldContent = this.drags[index].textarea;
      this.$set(this.drags[index], "textarea", content);
      this.drags[index].height = height;
      this.$forceUpdate();
      this.$nextTick(() => {
        this.savePlateContent();
      });
    },
    onChangeAutoSize(e) {
      console.log(e);
      this.drags[this.activeIndex].lineHeightAutoSize = e.target.checked
        ? 1
        : 0;
      if (e.target.checked) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(
          this.drags[this.activeIndex].fSize * 1.23
        );
      }
      this.$forceUpdate();
    },
    clear() {
      this.drags[this.activeIndex].fontWeight = "";
      this.drags[this.activeIndex].fontStyle = "";
      this.drags[this.activeIndex].textDecoration = "";
      this.drags[this.activeIndex].fontFamily = "";

      this.drags[this.activeIndex].fColor = "#101010";
      this.drags[this.activeIndex].textAlign = "left";
      this.drags[this.activeIndex].textIndent = 0;
      this.drags[this.activeIndex].bColor = "";
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(14 * 1.23);
      }
      this.drags[this.activeIndex].fSize = 14;
      this.$forceUpdate();
    },
    changeB() {
      const s = this.drags[this.activeIndex].fontWeight == "bold" ? "" : "bold";
      this.$set(this.drags[this.activeIndex], "fontWeight", s);
    },
    changeI() {
      const s =
        this.drags[this.activeIndex].fontStyle == "italic" ? "" : "italic";
      this.$set(this.drags[this.activeIndex], "fontStyle", s);
    },
    changeFSize(size) {
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(size * 1.23);
      }
      this.$set(this.drags[this.activeIndex], "fSize", size);
    },
    changeFamily(name) {
      this.$set(this.drags[this.activeIndex], "fontFamily", name);
    },
    handleChangeFamily() {
      this.familyMask = true;
    },
    changeU() {
      const s =
        this.drags[this.activeIndex].textDecoration == "underline"
          ? ""
          : "underline";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    changeS() {
      const s =
        this.drags[this.activeIndex].textDecoration == "line-through"
          ? ""
          : "line-through";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    addTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 9) return false;

      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent + 1
        : 1;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    decTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 0) return false;
      console.log(this.drags[this.activeIndex].textIndent);
      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent - 1
        : 0;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    handleMoveCom(e) {
      e.preventDefault;
      e.stopPropagation;
    },

    rightClick(e) {
      console.log(e);
    },
    handleSelectCombination(e, index) {
      e.preventDefault;
      e.stopPropagation;
      console.log(index);
      this.ComIndex = index;
      // var fixcom = document.getElementById("fixcom");
      // console.log(this.$refs.comItem[index]);
      // this.comHtml = this.$refs.comItem[index];
    },
    handleEndMovecom() {
      console.log("111");
      setTimeout(() => {
        this.ComIndex = -1;
      }, 400);
    },
    mouseUpCombination() {},
    handleSelectPhoto2(photo, index) {
      console.log(photo);
      this.selectPhoto = photo;
      console.log(this.$refs.frame[index].height);
      this.selectHeight = (160 / 100) * this.$refs.frame[index].height;
    },
    handleAddSquire(index) {
      this.selectPhoto = this.suireList[index];
    },
    handleSelectPhotoUrl(url, index) {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 160,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: this.clearUrl(url),
        backImg2: "",
        borderRadius: 0,
        type: 0,
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
      this.selectHeight = (160 / 100) * this.$refs.paster[index].height;
      console.log(this.selectPhoto);
    },
    handleSelectText() {
      this.selectPhoto = this.texts;
    },
    handleStarSelect() {
      this.selectPhoto = this.stars;
    },
    calcelPhoto() {
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = "";
      } else {
        this.drags[this.activeIndex].showPhoto = "";
      }
    },
    dropImg(index, e) {
      if (this.selectPhoto || this.ComIndex > -1) {
        this.addDrag(e);
        return false;
      }
      if (!this.selectImg) return false;
      if (this.drags[index].type == 1 || this.drags[index].type == 9) {
        this.drags[index].backgroundImg = this.clearUrl(this.selectImg);
      } else if (this.drags[index].type == 2) {
        this.drags[index].showPhoto = this.clearUrl(this.selectImg);
      }
      this.selectImg = "";
    },
    mouseUpPhoto() {
      setTimeout(() => {
        this.selectPhoto = null;
      }, 80);
    },
    handleSelectPhoto(img) {
      this.selectImg = img;
    },
    listenMouseEnter(dragIndex, zIndex) {
      this.mouseIn.push(this.dragIndex);
    },
    listenMouseLeave(dragIndex, zIndex) {
      this.mouseIn.forEach((arr, index) => {
        if (arr == dragIndex) {
          this.mouseIn.splice(index, 1);
        }
      });
    },
    up() {
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1) {
        return false;
      }

      this.drags = this.drags.map((arr, index) => {
        if (
          this.drags[index].zIndex ==
          this.drags[this.activeIndex].zIndex + 1
        ) {
          arr.zIndex--;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex++;
      this.changeDragHistory(this.activeIndex);
      this.savePlateContent();
    },
    down() {
      if (this.drags[this.activeIndex].zIndex == 0) return false;

      this.drags = this.drags.map((arr, index) => {
        if (
          this.drags[index].zIndex ==
          this.drags[this.activeIndex].zIndex - 1
        ) {
          arr.zIndex++;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex--;
      this.changeDragHistory(this.activeIndex);
    },
    toTop() {
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1) {
        return false;
      }

      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex > this.drags[this.activeIndex].zIndex) {
          arr.zIndex--;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = this.drags.length - 1;
      this.changeDragHistory(this.activeIndex);
    },
    toBottom() {
      if (this.drags[this.activeIndex].zIndex == 0) return false;
      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex < this.drags[this.activeIndex].zIndex) {
          arr.zIndex++;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = 0;
      this.changeDragHistory(this.activeIndex);
    },
    handledownZJ() {
      this.drags[this.activeIndex].active = true;
    },
    rotating(left, top, width, height, rotate, index) {
      this.drags[index].rotate = parseInt(rotate);
      this.changeDragHistory(index);
    },
    pmoving(left, top, scale, index) {
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.changeDragHistory(index);
    },
    movingStop(left, top, scale, index) {
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.changeDragHistory(index);
    },
    resizing(left, top, width, height, picLeft, picTop, index, raduis) {
      console.log("resizing");
      this.drags[index].left = parseInt(left) ? parseInt(left) : 0;
      this.drags[index].top = parseInt(top);
      this.drags[index].width = parseInt(width);
      this.drags[index].height = parseInt(height);
      this.drags[index].photoLeft = parseInt(picLeft);
      this.drags[index].photoTop = parseInt(picTop);
      if (raduis) {
        this.drags[index].borderRadius = parseInt(raduis);
      }
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    dragging(left, top, dragIndex) {
      console.log("dragging");
      this.drags[dragIndex].left = parseInt(left);
      this.drags[dragIndex].top = parseInt(top);
      this.changeDragHistory(dragIndex);
    },
    removeDrag(index) {
      var delZindex = this.drags[index].zIndex;
      var drag = _.cloneDeep(this.drags[index]);
      this.drags = this.drags.splice(index, 1);
      if (this.drags.length > 0) {
        this.drags.forEach((arr) => {
          if (arr.zIndex > delZindex) {
            arr.zIndex--;
          }
          return arr;
        });
      } else {
        this.activeIndex = 0;
      }
      this.czHistory = [
        ...this.czHistory,
        {
          type: "delete",
          index: index,
          detail: drag,
        },
      ];
      this.originDrags = _.cloneDeep(this.drags);
    },
    dqdrags(mode) {
      if (this.dragsSelectIndexs.length < 2) {
        return;
      }
      let x2, y2;
      switch (mode) {
        case "left":
          x2 = this.selectXY.minX;
          y2 = 0;
          break;

        case "right":
          x2 = this.selectXY.maxX;
          y2 = 0;
          break;

        case "top":
          x2 = 0;
          y2 = this.selectXY.minY;
          break;

        case "bottom":
          x2 = 0;
          y2 = this.selectXY.maxY;
          break;

        case "horCenter":
          x2 = (this.selectXY.minX + this.selectXY.maxX) / 2;
          y2 = 0;
          break;
        case "verCenter":
          x2 = 0;
          y2 = (this.selectXY.minY + this.selectXY.maxY) / 2;
          break;

        default:
          break;
      }
      this.moveDrags(mode, x2, y2);
    },
    moveDrags(mode, moveX, moveY) {
      console.log(mode, moveX, moveY);
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        const arrayX = [];
        const arrayY = [];
        this.dragsSelectList[index].forEach((arr2) => {
          arrayX.push(arr2.x);
          arrayY.push(arr2.y);
        });
        const orginXy = {
          minX: _.min(arrayX),
          minY: _.min(arrayY),
          maxX: _.max(arrayX),
          maxY: _.max(arrayY),
        };
        switch (mode) {
          case "left":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left - (orginXy.minX - moveX)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "right":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left - (orginXy.maxX - moveX)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "top":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top - (orginXy.minY - moveY)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "bottom":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top - (orginXy.maxY - moveY)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          case "horCenter":
            this.$set(
              this.drags[dragIndex],
              "left",
              this.drags[dragIndex].left -
                (this.drags[dragIndex].left +
                  this.drags[dragIndex].width / 2 -
                  moveX)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;
          case "verCenter":
            this.$set(
              this.drags[dragIndex],
              "top",
              this.drags[dragIndex].top -
                (this.drags[dragIndex].top +
                  this.drags[dragIndex].height / 2 -
                  moveY)
            );
            this.initSelectDom();
            this.$nextTick(() => {
              this.calcDrag(this.activeIndex);
            });
            break;

          default:
            break;
        }
        this.dq_step = true;
      });
    },
    initSelectDom() {
      const list = [];
      const arrayX = [];
      const arrayY = [];
      let minx, miny, maxX, maxY;
      this.dragsSelectIndexs.forEach((dragIndex, index) => {
        console.log(dragIndex);
        const arr = this.drags[dragIndex];
        const xy = getCoordinate(
          arr.left + arr.width / 2,
          arr.top + arr.height / 2,
          arr.rotate,
          arr.left,
          arr.top
        );
        xy.forEach((arr2) => {
          arrayX.push(arr2.x);
          arrayY.push(arr2.y);
        });
        list.push(xy);
      });
      this.dragsSelectList = [...list];
      this.arrayX = arrayX;
      this.arrayY = arrayY;
      this.selectXY = {
        minX: _.min(arrayX),
        minY: _.min(arrayY),
        maxX: _.max(arrayX),
        maxY: _.max(arrayY),
      };
      this.dragsSelectIndexs.forEach((arr) => {
        this.$refs.drag[arr].activeDrag();
      });
    },
    calcDrag(index) {
      this.drags[index].active = true;
      this.drags[index].draggable = true;
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      this.moveBoxRight =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    changeDrag(index) {
      if (this.keyDown.shiftKey && this.dragsSelect) {
        let isCF = false;
        this.dragsSelectIndexs.forEach((dragIndex) => {
          if (dragIndex === index) {
            isCF = true;
          }
        });
        if (isCF) {
        } else {
          this.dragsSelect = [...this.dragsSelect, { ...this.drags[index] }];
          this.dragsSelectIndexs = [...this.dragsSelectIndexs, index];
          console.log(this.dragsSelect);
        }
        if (this.dragsSelect && this.dragsSelect.length === 2) {
          // if (this.dragsSelect[0].index > index) {
          //   this.drags.splice(this.dragsSelect[0].index, 1)
          //   this.drags.splice(index, 1)
          // } else {
          //   this.drags.splice(index, 1)
          //   this.drags.splice(this.dragsSelect[0].index, 1)
          // }
        } else {
          // this.drags.splice(index, 1)
        }
        // this.initSelectDom()
        // this.dragSelectMode = true

        // this.initSelectDom();

        this.addCom();
        if (this.dragsSelect && this.dragsSelect.length == 1) {
          this.multipleDrag = null;
          this.dq_step = false;
          this.dragsSelect = null;
          this.dragsSelectIndexs = null;
          this.dragsSelect = [{ ...this.drags[index] }];
          this.dragsSelectIndexs = [index];
          this.dragsSelect[0].index = index;
          this.$set(this.drags[index], "shiftkey", true);
          this.uploadWaitDrag();
          this.activeIndex = index;
          var orignX =
            this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
          var orignY =
            this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

          this.moveBoxRight =
            this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
          this.moveBoxTop =
            this.$refs.drag[index].top +
            this.$refs.drag[index].getHeight() / 2 -
            67;
          this.transformX = orignX - this.moveBoxRight;
          this.transformY = orignY - this.moveBoxTop;
          this.rotateStyles = {
            top: this.$refs.drag[index].top - 10,
            left:
              this.$refs.drag[index].left +
              this.$refs.drag[index].width / 2 -
              22,
            rotateX:
              orignX -
              (this.$refs.drag[index].left +
                this.$refs.drag[index].width / 2 -
                22),
            rotateY: orignY - (this.$refs.drag[index].top - 10),
          };
          this.moveBoxRotate = this.$refs.drag[index].rotate;
          this.tabIndex = 0;
          this.showIcon = true;
          // setTimeout(() => {
          //   this.$refs["drag"][index].active = false
          //   this.$refs["drag"][index].cancelActive()
          // }, 100);

          this.batchGetElement(this.drags[index].eguc_id);
        }
      } else {
        console.log("31231231");
        this.dq_step = false;
        this.dragsSelect = null;
        this.dragsSelectIndexs = null;
        this.dragsSelect = [{ ...this.drags[index] }];
        console.log(this.dragsSelect);
        this.dragsSelectIndexs = [index];
        this.dragsSelect[0].index = index;
        this.$set(this.drags[index], "shiftkey", true);
        this.activeIndex = index;
        this.tabIndex = 0;
        this.drags[index].active = true;
        this.drags[index].draggable = true;
        this.$forceUpdate();
        var orignX =
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
        var orignY =
          this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

        this.moveBoxRight =
          this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
        this.moveBoxTop =
          this.$refs.drag[index].top +
          this.$refs.drag[index].getHeight() / 2 -
          67;
        this.transformX = orignX - this.moveBoxRight;
        this.transformY = orignY - this.moveBoxTop;
        this.rotateStyles = {
          top: this.$refs.drag[index].top - 10,
          left:
            this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
          rotateX:
            orignX -
            (this.$refs.drag[index].left +
              this.$refs.drag[index].width / 2 -
              22),
          rotateY: orignY - (this.$refs.drag[index].top - 10),
        };
        this.moveBoxRotate = this.$refs.drag[index].rotate;
      }
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params;
      let id = 0;
      this.vLine = vLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
      this.hLine = hLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
    },
    addText() {
      return false;
      if (!this.backgroundImage) {
        this.$message.error("请先添加背景");
        return false;
      }
      var item = this.texts;
      var drag = {
        allIndex: this.drags.length + 1,
        left: this.wrapperWidth / 2 - item.width / 2,
        top: 350 - (item.height ? item.height : 0) / 2,
        width: item.width,
        height: item.height ? item.height : "auto",
        rotate: item.rotate,
        lockAspectRatio: item.lockAspectRatio,
        textarea: item.textarea,
        minW: item.minW,
        minH: item.minH,
        type: item.type,
        backgroundImg: item.type == 1 ? "" : item.backgroundImg,
        backImg2: item.backImg2,
        maxW: item.maxW,
        maxH: item.maxH,
        lock: item.lock,
        zIndex: this.drags.length + 1,
        bColor: item.bColor,
        fColor: item.fColor,
        bordersColor: item.bordersColor,
        bLeft: item.bLeft,
        bTop: item.bTop,
        bRight: item.bRight,
        bBottom: item.bBottom,
        bStyle: item.bStyle,
        paddingLeft: item.paddingLeft,
        paddingTop: item.paddingTop,
        paddingRight: item.paddingRight,
        paddingBottom: item.paddingBottom,
        opacity: item.opacity,
        showPhoto: item.showPhoto,
        lineHeight: item.lineHeight,
        fontWeight: item.fontWeight,
        fontStyle: item.fontStyle,
        textAlign: item.textAlign,
        combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
      };
      this.drags = [...this.drags, drag];
      this.drags.forEach((arr, index) => {
        arr.active = false;
        arr.draggable = false;
        if (index == this.drags.length - 1) {
          arr.active = true;
          arr.draggable = true;
        }
        return arr;
      });
      this.activeIndex = this.drags.length - 1;
      this.allIndex = this.drags.length;
      this.czHistory = [
        ...this.czHistory,
        {
          type: "adddrag",
          index: null,
          detail: drag,
        },
      ];
      this.originDrags = _.cloneDeep(this.drags);
    },
    addPhoto2(url) {
      return false;
      if (!this.backgroundImage) {
        this.$message.error("请先添加背景图");
        this.ComIndex = -1;
        this.selectPhoto = null;
        return false;
      }
      console.log(url);
      var drag = {
        left: this.wrapperWidth / 2 - 160 / 2,
        top: 330,
        width: 160,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: url,
        backImg2: "",
        borderRadius: 0,
        type: 1,
        lineHeight: "18",
        fontStyle: "normal",
        fontWeight: "normal",
        textAlign: "left",
      };
      this.drags = [...this.drags, drag];
      this.drags.forEach((arr, index) => {
        arr.active = false;
        arr.draggable = false;
        if (index == this.drags.length - 1) {
          arr.draggable = true;
          arr.active = true;
        }
        return arr;
      });
      this.activeIndex = this.drags.length - 1;
      this.allIndex = this.drags.length;
      this.czHistory = [
        ...this.czHistory,
        {
          type: "adddrag",
          index: null,
          detail: drag,
        },
      ];
      this.originDrags = _.cloneDeep(this.drags);
    },
    addPhoto(item) {
      if (!this.backgroundImage) {
        this.$message.error("请先添加背景图");
        this.ComIndex = -1;
        this.selectPhoto = null;
        return false;
      }
      var drag = {
        allIndex: this.drags.length + 1,
        left: this.wrapperWidth / 2 - item.width / 2,
        top: 350 - (item.height ? item.height : 0) / 2,
        width: item.width,
        height: item.height ? item.height : "auto",
        rotate: item.rotate,
        lockAspectRatio: item.lockAspectRatio,
        textarea: item.textarea,
        minW: item.minW,
        minH: item.minH,
        type: item.type,
        backgroundImg: item.type == 1 ? "" : item.backgroundImg,
        backImg2: item.backImg2,
        maxW: item.maxW,
        maxH: item.maxH,
        lock: !!item.lock,
        zIndex: this.drags.length + 1,
        bColor: item.bColor,
        fColor: item.fColor,
        bordersColor: item.bordersColor,
        bLeft: item.bLeft,
        bTop: item.bTop,
        bRight: item.bRight,
        bBottom: item.bBottom,
        bStyle: item.bStyle,
        paddingLeft: item.paddingLeft,
        paddingTop: item.paddingTop,
        paddingRight: item.paddingRight,
        paddingBottom: item.paddingBottom,
        opacity: item.opacity,
        showPhoto: item.showPhoto,
        lineHeight: item.lineHeight,
        fontWeight: item.fontWeight,
        fontStyle: item.fontStyle,
        textAlign: item.textAlign,
      };
      this.drags = [...this.drags, drag];
      this.drags.forEach((arr, index) => {
        arr.active = false;
        arr.draggable = false;
        if (index == this.drags.length - 1) {
          arr.draggable = true;
          arr.active = true;
        }
        if (arr.coms) {
          arr.coms = JSON.parse(arr.coms);
          if (arr.coms[0] && arr.coms[0].width >= 0) {
          } else {
            arr.coms = [];
          }
        }
        arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
        return arr;
      });
      this.activeIndex = this.drags.length - 1;
      this.allIndex = this.drags.length;
      this.czHistory = [
        ...this.czHistory,
        {
          type: "adddrag",
          index: null,
          detail: drag,
        },
      ];
      this.originDrags = _.cloneDeep(this.drags);
    },
    changeTab(index) {
      this.tabIndex = index;
    },
    selectPlate(index) {
      this.plateList = this.plateList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.plateList[index].select = true;
      this.$forceUpdate();
    },
    changeBack(url) {
      this.$confirm({
        title: "确认替换背景吗?",
        content: "背景替换后可能无法撤销，请谨慎使用",
        centered: true,
        onOk: () => {
          var originUrl = this.backgroundImage;
          this.backgroundImage = this.clearUrl(url);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          this.czHistory = [
            ...this.czHistory,
            {
              type: "changeBack",
              index: null,
              detail: originUrl,
            },
          ];
          this.step = this.czHistory.length - 1;
        },
      });
    },
    changeImgs(url) {
      this.drags[this.activeIndex].active = true;
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = this.clearUrl(url);
      } else {
        this.drags[this.activeIndex].showPhoto = this.clearUrl(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rotatebox {
  position: absolute;
  width: 44px;
  z-index: 1100;
  right: 0;
  top: 0;
  height: 44px;
  text-align: center;

  &::before {
    font-size: 22px;
    color: #399fe4;
    font-weight: bold;
    line-height: 44px;
    text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0;
  }
  i {
    font-size: 22px;
    color: #399fe4;
    font-weight: bold;
    line-height: 44px;
  }
}
.moveBOX {
  position: absolute;
  width: 45px;
  z-index: 1100;
  display: flex;
  // background: #fff;
  padding: 4px 0px;
  right: -40px;
  top: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  i {
    font-size: 25px;
    color: #399fe4;
  }
  img {
    width: 28px;
    height: 28px;
    margin: 6px 0;
    &:nth-child(1) {
      cursor: move;
    }
  }
}
.raduis .el-input-number {
  width: 90px;
  margin-right: 3px;
}
.fixtop {
  position: fixed;
  left: 0;
  right: 381px;
  box-sizing: border-box;
  top: 0;
  height: 60px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 30;
  .right {
    position: absolute;
    right: 10px;
    top: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .save {
      background: #746bff;
      color: #fff;
      text-align: center;
      padding: 4px 12px;
      font-size: 12px;
      border-radius: 2px;
    }
  }
  .cz {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 250px;
    margin-right: 10px;
    text-align: center;
    font-size: 12px;
    color: #5d5d5d;
    .cz-item {
      flex: 1 1 0%;
      cursor: pointer;
      .name {
        margin-top: 4px;
      }
    }
  }
}
.item-line .input {
  width: 120px;
}
.num-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .num-cell {
    margin-right: 10px;
  }
  i {
    margin-right: 8px;
  }
  .el-input-number {
    width: 90px;
  }
}
.flex-1 {
  flex: 1 1 0%;
}
.section {
  width: 100%;
  .section-item {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    .item-line {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      margin-bottom: 10px;
      span.name2 {
        font-size: 14px;
        color: rgb(141, 158, 167);
        line-height: 38px;
        margin: 0 10px;
        box-sizing: border-box;
        width: 20px;
      }
      .title {
        flex: 1 1 0%;
      }
      .cell {
        box-sizing: border-box;
        width: 160px;
        display: flex;
        margin-right: 12px;
        flex-direction: row;
        align-items: center;
        color: rgb(125, 139, 148);
        span.name {
          font-size: 14px;
          color: rgb(141, 158, 167);
          line-height: 38px;
          margin: 0 10px;
          box-sizing: border-box;
          width: 20px;
        }
      }
      .el-input-number {
        flex: 1 1 0%;
      }
    }
  }
}
.fixbtn {
  position: fixed;
  display: flex;
  flex-direction: column;
  .ant-btn {
    margin-bottom: 10px;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    user-select: none;
    .item {
      cursor: pointer;
    }
  }
}
.backimg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
}
.photo-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.build-item {
  width: 99px;
  height: 99px;
  overflow: hidden;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  -webkit-user-drag: element;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #f3f3f3;
  .wrap {
    position: relative;
  }
  .img {
    width: 100%;
    height: auto;
  }
  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}
.priview-img {
  position: fixed;
  top: 60px;
  right: 381px;
  width: 380px;
}
.photo-item {
  width: 99px;
  float: left;
  box-sizing: border-box;
  margin: 10px;
  position: relative;
  .img {
    width: 100%;
    height: auto;
  }
  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}
.dragtext {
  width: 99px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  color: #333;
  border: 1px solid #666;
  margin-bottom: 10px;
}
.photo-item .look {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.back-item {
  width: 99px;
  float: left;
  box-sizing: border-box;
  margin: 10px;
}
.plate-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  .cell {
    width: 134px;
    margin-right: 20px;
    height: 180px;
    background: #eee;
    position: relative;
    margin-bottom: 60px;
    &.select {
      border: 2px solid #9ebee4;
    }
    .name {
      position: absolute;
      left: 0;
      top: 185px;
      color: #888;
      line-height: 1.2;
      padding: 5px;
      box-sizing: border-box;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}
.back-item .back {
  width: 100%;
  margin-bottom: 10px;
  max-height: 160px;
  box-sizing: border-box;
  overflow: hidden;
  background-position: 0 0;
  background-size: contain;
  background-repeat: no-repeat;
}
.back-item .back .img {
  width: 100%;
  height: auto;
  background: #f3f3f3;
  display: block;
}
.photo-item .look .img {
  width: 100%;
  background: #f3f3f3;
  display: block;
}
.photo-item .name {
  text-align: center;
}
body,
html {
  background: #f3f3f3;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}
textarea {
  width: 100%;
  height: auto;
  max-height: 100%;
  border: none;
  // outline: none;
}

.mask2 {
  position: absolute;
  right: 0;
  top: 0;
  content: "";
  bottom: 0;
  width: 379px;
  z-index: 100;
  background: rgba($color: #000000, $alpha: 0.6);
}
.leftChat {
  box-sizing: border-box;
  padding-right: 360px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 820px;
  overflow: hidden;
}
.body {
  -webkit-text-size-adjust: none;
  overflow: hidden;
  position: relative;
  width: 432px;
  height: 700px;
  min-height: 600px;
  border: 1px solid #999;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px)
      10px 10px / 20px 20px,
    linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px) 0% 0% / 20px 20px;
}
.test1 {
  background-color: #fff;
}
.test1 img {
  width: 100%;
  height: 100%;
}
textarea {
  background: transparent;
}
.rightChat {
  position: fixed;
  right: 0;
  top: 0;
  width: 381px;
  height: 100vh;
  background: #fff;
  overflow-y: scroll;
  z-index: 20;
  display: flex;
  flex-direction: column;
  .content {
    overflow-x: hidden;
    flex: 1 1 0%;
    padding-bottom: 55px;
    box-sizing: border-box;
  }
}
.rightChat .tabbar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
}
.rightChat .tabbar .tab-item {
  padding: 8px 8px;
  cursor: pointer;
  font-size: 14px;
}
.rightChat .tabbar .tab-item.active {
  color: #746bff;
  position: relative;
}
.rightChat .tabbar .tab-item.active::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 2px;
  background: #746bff;
  content: "";
}
.searchbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 20px 10px 10px;
  box-sizing: border-box;
  :deep(.ant-input-search) {
    flex: 1 1 0%;
  }
}
.rightChat .tabbar .tab-item.active::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 2px;
  background: #746bff;
  content: "";
}
textarea {
  width: 100%;
  height: auto;
  max-height: 100%;
  border: none;
  // outline: none;
}
.text {
  box-sizing: border-box;
}
#app,
.app {
  background: #f3f3f3;
  width: 100%;
}
.frameModal {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.pagebox {
  position: absolute;
  bottom: 15px;
  left: 5px;
  right: 5px;
}
.section {
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .label {
      flex: 1 1 0%;
      border-radius: 5px;
      border: 1px solid #eee;
      text-align: center;
      margin-left: 10px;
      padding: 2px 0;
      cursor: pointer;
      &.active {
        background: #e1eff8;
      }

      &:first-child {
        margin-left: 0;
      }

      &.outline {
        border: none;
      }
    }
  }

  .col-3 {
    width: 100% !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #f3f3f3;
    padding: 5px;
    border-radius: 5px;

    .cell {
      flex: 1 1 0%;
      border-radius: 5px;
      border: 1px solid #eee;
      text-align: center;
      margin-right: 10px;
      font-weight: bold;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 0;

      &.active {
        background: #fff;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.bottomChat {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 381px;
  background: #fff;
  height: 75px;
  box-sizing: border-box;
  .pagebox {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    box-sizing: border-box;
    align-items: center;
    overflow-x: scroll;
    bottom: 4px;
    height: 67px;
    margin-top: 4px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
      cursor: pointer;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background-color: #56b1db;
      background-image: -webkit-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent
      );
    }

    .item {
      width: 28px;
      flex-shrink: 0;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      margin-right: 4px;
      color: #16bda4;
      cursor: pointer;
    }
    .add-page {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      flex-shrink: 0;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      box-sizing: border-box;
      padding: 0;
      color: #16bda4;
      margin-right: 4px;
      cursor: pointer;
      margin-right: 20px;
    }
    .active {
      background: #00d182;
      color: #fff;
    }
  }
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.savebox {
  margin-right: 12px;
  span {
    margin-left: 5px;
  }
}
.sizebox {
  .name {
    margin-right: 5px;
  }
}
.ant-modal-body .quill-editor {
  height: 320px !important;
}
.raduis .el-input-number {
  width: 90px;
  margin-right: 3px;
}
.ql-container {
  height: 320px;
  -webkit-text-size-adjust: none;
}
.raduis .el-input-number {
  width: 90px;
  margin-right: 3px;
}

.selectFamily {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 300px;
  background: #fff;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow-y: scroll;
  z-index: 1000;

  div {
    font-size: 14px;
    background: #fff;
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
.dq_none i {
  color: #ccc;
}
.rightfix {
  position: fixed;
  right: 381px;
  bottom: 150px;
  img {
    width: 26px;
    margin-right: 5px;
    margin-top: -2px;
  }
  .pull-p {
    padding: 8px 15px 8px 8px;
    background: #679dbd;
    color: #fff;
    border-radius: 30px 0 0 30px;
    cursor: pointer;
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .clear-p {
    background: #e73a37;
    padding: 8px 15px 8px 8px;
    color: #fff;
    border-radius: 30px 0 0 30px;
    cursor: pointer;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.left-tools {
  position: fixed;
  left: 20px;
  top: 75px;
  background: #fff;
  width: 110px;
  height: 50px;
  padding: 10px 5px 10px 8px;
  display: flex;
  flex-direction: row;

  .item {
    flex: 1 1 0%;
    margin: 0 4px;
    display: flex;
    float: left;
    align-items: center;
    justify-content: center;
    height: 30px;
    -webkit-user-drag: element;

    &:hover {
      background: #eee;
    }

    .type-line {
      width: 17px;
      height: 2px;
      background: #6a6a6a;
      border-radius: 2px;
      transform: rotate(-45deg);
    }

    .type-squire {
      width: 20px;
      height: 16px;
      border: 2px solid #6a6a6a;
      border-radius: 2px;
    }

    .type-circle {
      width: 18px;
      height: 18px;
      border-radius: 20px;
      border: 2px solid #6a6a6a;
    }
  }
}
.align-item {
  text-align: center;
}

.fenpage-modal .head {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
}
.fenpage-modal .head .title {
  color: #f39800;
  font-weight: bold;
  font-size: 20px;
}
.fenpage-modal .head .tip {
  font-size: 14px;
}
.fenpage-modal .head .tip span {
  color: #1587d3;
  margin: 0 6px;
}
.fenpage-modal img {
  width: 60px;
  margin-right: 20px;
}

.fenpage-modal .item {
  margin: 3px 0;
}

.fenpage-modal .select {
  width: 110px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  background: #85bed6;
  border-radius: 6px;
  margin: 40px auto 0 auto;
  cursor: pointer;
  position: relative;
}

.fenpage-modal .select::before {
  position: absolute;
  left: 120px;
  width: 160px;
  height: 1px;
  background: #85bed6;
  content: "";
  top: 50%;
  transform: translateY(-50%);
}

.fenpage-modal .select::after {
  position: absolute;
  right: 120px;
  width: 160px;
  height: 1px;
  background: #85bed6;
  content: "";
  top: 50%;
  transform: translateY(-50%);
}

.fenpage-modal .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #85bed6;
  border-color: #85bed6;
}

.fixtop .left {
  position: absolute;
  left: 0px;
  top: 0;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.ant-page-header-heading .ant-page-header-heading-title {
  color: #399fe4;
}
</style>
